// @flow

import React from 'react';
import { ReactSVG } from 'react-svg';
import LogoIcon from '../../assets/orca-logo-black.svg';
import LoginLogoIcon from '../../assets/orca-logo-black.svg';
import LogoApollo from '../../assets/Apollo.png';
import { Tooltip } from 'antd';
import { FormattedMessage } from 'react-intl';

export const Logo = <ReactSVG src={LogoIcon} />;

// <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 372.73 381.2">
//     <path
//         d="M250.2,295.24c-.47,3-1.47,5.67-3,7.27-3.34,3.4-7.52-2.28-9.85-8.33-2-5.15,1.64-10.3,4-13.33,1.82-2.36,4.19-2.48,6.1-.29-2.39-9-6.07-17.48-11.75-23.24-13-13.19-30.16-17.38-40.22-18.73,0-78.1-3.77-141.42-8.41-141.42s-8.43,63.24-8.43,141.27c-9.88,1.18-27.9,5.19-41.35,18.88-5.7,5.79-9.4,14.26-11.78,23.35,1.93-2.3,4.35-2.23,6.2.18,2.33,3,6,8.18,4,13.33-2.34,6-6.51,11.73-9.85,8.33-1.62-1.64-2.63-4.42-3.08-7.5a181.89,181.89,0,0,0-1.11,33.32c18.84-19.18,39.93-4.51,47.6-.67a44.21,44.21,0,0,0,16.61,4h1.29a44.21,44.21,0,0,0,16.61-4c7.67-3.84,28.76-18.51,47.61.67A183.91,183.91,0,0,0,250.2,295.24Zm4.08,42.16s1.36,41.85,46.22,43.23,62.13-.16,62.13-.16,26.3-2.52-6-6.66c-24.46-3.13-37.31-12.72-42.58-17S287.2,329.5,254.28,337.4Zm-135.82,0c-32.92-7.9-54.52,15-59.79,19.36s-18.14,13.92-42.59,17c-32.27,4.14-6,6.66-6,6.66s17.29,1.54,62.14.16,46.24-43.18,46.24-43.18Zm130.74-.32a13.73,13.73,0,0,0-8.75-7.4s.68,46.08-90.43,33.57C150,363.25,238.59,385.21,249.2,337.08Z"
//         transform="translate(0)"
//     />
//     <path
//         d="M140.57,196.33l4.63-14.26a93.54,93.54,0,0,1,0-167.81L140.6,0a108.4,108.4,0,0,0,0,196.33Z"
//         transform="translate(0)"
//     />
//     <path
//         d="M259.9,98.17a73.48,73.48,0,0,0-38.39-64.58l-2.78,8.58a64.55,64.55,0,0,1,13.49,101.68,64.36,64.36,0,0,1-13.43,10.3l2.77,8.58A73.44,73.44,0,0,0,259.9,98.17Z"
//         transform="translate(0)"
//     />
//     <path
//         d="M113.06,98.17a73.43,73.43,0,0,0,38.37,64.52l2.77-8.58a64.6,64.6,0,0,1,0-112l-2.78-8.58a73.5,73.5,0,0,0-38.36,64.64Z"
//         transform="translate(0)"
//     />
//     <path
//         d="M232.35,0l-4.6,14.25a93.54,93.54,0,0,1,0,167.82l4.6,14.26A108.39,108.39,0,0,0,232.35,0Z"
//         transform="translate(0)"
//     />
// </svg>
// );

export const LogoType = () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 65.52 15.84">
        <path
            d="M494.73,521h-4.47l2.29-5Zm.9,2.07,1.54,3.56h2.43l-7-15.57-7.27,15.57h2.39l1.64-3.56Zm-14.9-10.31a7.56,7.56,0,0,0-3.83-1.06,7.41,7.41,0,0,0-5.91,2.68,7.55,7.55,0,0,0-1.85,5,7.31,7.31,0,0,0,2.21,5.34,7.4,7.4,0,0,0,5.38,2.19,8,8,0,0,0,4-1.08v-2.67c-.36.3-.71.56-1,.78a6.88,6.88,0,0,1-.95.51,4.77,4.77,0,0,1-2,.38,5.21,5.21,0,0,1-3.83-1.58,5.35,5.35,0,0,1-1.56-3.89,5.45,5.45,0,0,1,1.56-4,5.07,5.07,0,0,1,3.82-1.63,6.17,6.17,0,0,1,4,1.61Zm-23.16,6V514h.79q3.06,0,3.06,2.25,0,2.4-3.15,2.4Zm2.76,1.68a4.06,4.06,0,0,0,2.36-1.43,4.2,4.2,0,0,0,.89-2.68,4,4,0,0,0-1.43-3.21A6.47,6.47,0,0,0,458,512h-2.6v14.65h2.22v-6h.4l4.19,6h2.72Zm-24-1.13a5.43,5.43,0,0,1,5.45-5.48,5.15,5.15,0,0,1,3.86,1.6,5.32,5.32,0,0,1,1.57,3.92,5.39,5.39,0,0,1-1.58,3.93,5.45,5.45,0,0,1-9.3-4Zm-2.24,0a7.17,7.17,0,0,0,2.49,5.69,7.78,7.78,0,0,0,10.61-.24,7.2,7.2,0,0,0,2.26-5.36,7.67,7.67,0,0,0-7.64-7.63,7.52,7.52,0,0,0-5.45,2.23A7.18,7.18,0,0,0,434.08,519.22Z"
            transform="translate(-434.08 -511.04)"
        />
    </svg>
);

export const LogoAndLogoType = () => (
    <div className="full-logo">
        <span>
            <ReactSVG src={LogoIcon} />
        </span>
        <span>
            <LogoType />
        </span>
    </div>
);

export const Menu = () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18.72 14.4">
        <path
            d="M458.34,525.2a.8.8,0,0,0,0,1.6H475.5a.8.8,0,0,0,0-1.6Zm0-6.4a.8.8,0,0,0,0,1.6H475.5a.8.8,0,0,0,0-1.6Zm0-6.4a.8.8,0,0,0,0,1.6H475.5a.8.8,0,0,0,0-1.6Z"
            transform="translate(-457.56 -512.4)"
        />
    </svg>
);

export const Search = () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18.72">
        <path
            d="M472.73,556.49l-4.44-4.63a7.52,7.52,0,1,0-5.76,2.7,7.46,7.46,0,0,0,4.31-1.37l4.47,4.67a1,1,0,1,0,1.42-1.37Zm-10.2-15.08A5.59,5.59,0,1,1,457,547,5.58,5.58,0,0,1,462.53,541.41Z"
            transform="translate(-455 -539.44)"
        />
    </svg>
);

export const User = () => (
    <Tooltip placement="right" title={<FormattedMessage id="sideMenu.hoverMessages.Profil" />}>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18.72 18.72">
            <path
                d="M473.54,522.58a9.32,9.32,0,0,0-3.56-2.23,5.41,5.41,0,1,0-6.12,0,9.36,9.36,0,0,0-6.3,8.85H459a7.9,7.9,0,1,1,15.8,0h1.46A9.3,9.3,0,0,0,473.54,522.58Zm-6.62-2.74a4,4,0,1,1,3.95-4A4,4,0,0,1,466.92,519.84Z"
                transform="translate(-457.56 -510.48)"
            />
        </svg>
    </Tooltip>
);
export const Admin = () => (
    <svg height="30px" id="Layer_3" version="1.1" viewBox="0 0 48 48" width="30px">
        <g>
            <path
                d="M23.999,22.863c-10.014,0-18.131,8.119-18.131,18.133v1.727v3.34v1.906h36.264v-1.906v-2.189v-2.877   C42.132,30.982,34.013,22.863,23.999,22.863z"
                fill="#241F20"
            />
            <path
                d="M14.479,15.936l1.859-0.656c0.502,0.837,1.148,1.593,1.916,2.236l-0.898,1.877l4.033,1.928l0.896-1.877   c0.963,0.189,1.933,0.22,2.88,0.095l0.682,1.934l3.371-1.191l-0.674-1.904c0.864-0.507,1.636-1.168,2.298-1.957l1.875,0.897   l1.923-4.02L32.763,12.4c0.195-0.986,0.225-1.983,0.09-2.951l1.858-0.655l-1.19-3.371l-1.859,0.655   c-0.499-0.834-1.144-1.587-1.907-2.229l0.898-1.879l-4.051-1.938l-0.898,1.881c-1.001-0.195-2.016-0.224-2.997-0.079l-0.63-1.785   l-3.373,1.191l0.641,1.815c-0.812,0.493-1.548,1.124-2.176,1.872l-1.879-0.898l-1.935,4.046l1.88,0.898   c-0.193,0.98-0.221,1.972-0.086,2.936l-1.859,0.655L14.479,15.936z M24,7.562c1.657,0,3,1.343,3,3s-1.343,3-3,3   c-1.657,0-3-1.343-3-3S22.343,7.562,24,7.562z"
                fill="#241F20"
            />
        </g>
    </svg>
);

export const Notification = () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 21.6">
        <path
            d="M475.94,527.19a.45.45,0,0,1-.39.23h-6.34a2.28,2.28,0,0,1,0,.45,2.25,2.25,0,0,1-4.5,0,2.3,2.3,0,0,1,.05-.45h-6.35a.46.46,0,0,1-.39-.68l1.55-2.58a7.68,7.68,0,0,0,1.09-3.93V518a6.32,6.32,0,0,1,4.5-6v-1.61a1.8,1.8,0,1,1,3.6,0v1.61a6.32,6.32,0,0,1,4.5,6v2.26a7.68,7.68,0,0,0,1.09,3.93l1.55,2.58A.45.45,0,0,1,475.94,527.19Zm-10.29.68a1.35,1.35,0,1,0,2.7,0,1.38,1.38,0,0,0-.08-.45h-2.54A1.38,1.38,0,0,0,465.65,527.87Zm2.25-17.55a.9.9,0,1,0-1.8,0v1.41a6.78,6.78,0,0,1,1.8,0Zm5.72,14.31a8.53,8.53,0,0,1-1.22-4.4V518a5.4,5.4,0,0,0-10.8,0v2.26a8.53,8.53,0,0,1-1.22,4.4l-1.14,1.89h15.51Z"
            transform="translate(-458 -508.52)"
        />
    </svg>
);

export const Map = () => (
    <Tooltip placement="right" title={<FormattedMessage id="sideMenu.hoverMessages.Survol" />}>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25.92 24.48">
            <path
                d="M458.37,527.71h-.05a.47.47,0,0,1-.47-.42,2.44,2.44,0,0,1,0-.27v-.16a3.52,3.52,0,0,1,.1-.65.47.47,0,0,1,.58-.33.46.46,0,0,1,.33.57,2.34,2.34,0,0,0-.07.45V527a1.09,1.09,0,0,0,0,.18A.47.47,0,0,1,458.37,527.71Zm2-2.55h-.19a1.33,1.33,0,0,0-.43.13.46.46,0,0,1-.22.06.49.49,0,0,1-.42-.24.47.47,0,0,1,.19-.63,2.09,2.09,0,0,1,.78-.24,1.89,1.89,0,0,1,.41,0,.46.46,0,0,1,.41.52A.45.45,0,0,1,460.33,525.16Zm.17,3.86a3.25,3.25,0,0,1-.44,0l-.36,0a1.55,1.55,0,0,1-.31-.06.46.46,0,1,1,.23-.89l.19,0a2.18,2.18,0,0,0,.57,0,.47.47,0,0,1,.53.4A.46.46,0,0,1,460.5,529Zm16.44-8.68a.49.49,0,0,1,.61.28,1.77,1.77,0,0,1,.12.64s0,.08,0,.12a2.41,2.41,0,0,1-.08.44.48.48,0,0,1-.45.33.32.32,0,0,1-.14,0,.45.45,0,0,1-.31-.57,1,1,0,0,0,0-.24v0a.87.87,0,0,0-.06-.32A.47.47,0,0,1,476.94,520.34Zm-1.83,2.75a1.65,1.65,0,0,0,.64-.24l0,0a.48.48,0,0,1,.66.09.47.47,0,0,1-.09.65l-.07,0a2.56,2.56,0,0,1-1,.4h-.1a.46.46,0,0,1-.46-.37A.47.47,0,0,1,475.11,523.09Zm-.82-3.18a.46.46,0,0,1,.32-.57,2.87,2.87,0,0,1,1.13-.08.46.46,0,0,1,.4.52.47.47,0,0,1-.53.4,1.69,1.69,0,0,0-.74.05l-.13,0A.47.47,0,0,1,474.29,519.91Zm-19.61,11.45L456.52,517h5.13a.47.47,0,1,1,0,.93h-4.3l-1.6,12.47h23.8L478.18,518H473.9a.47.47,0,1,1,0-.93H479l1.57,14.32Zm18.63-8.11a.5.5,0,0,1,.5.44.46.46,0,0,1-.45.48l-.95,0h0a.46.46,0,1,1,0-.92Zm-2.85.17a.46.46,0,1,1,.11.92c-.31,0-.61.09-.89.15h-.1a.48.48,0,0,1-.46-.37.47.47,0,0,1,.37-.55C469.79,523.52,470.12,523.47,470.46,523.42ZM465.91,526a.46.46,0,0,1-.09.65c-.26.19-.53.38-.8.55a.48.48,0,0,1-.26.07.46.46,0,0,1-.39-.21.44.44,0,0,1,.13-.63c.26-.16.51-.34.75-.52A.48.48,0,0,1,465.91,526Zm-2.37,1.52a.46.46,0,0,1-.22.61c-.3.14-.6.26-.9.38a.51.51,0,0,1-.17,0,.48.48,0,0,1-.44-.3.47.47,0,0,1,.27-.6c.28-.1.56-.22.84-.35A.46.46,0,0,1,463.54,527.5Zm4.71-3.06h0a.45.45,0,0,1-.21.59,3.72,3.72,0,0,0-.48.27l-.26.17a.47.47,0,0,1-.28.09.49.49,0,0,1-.38-.19.45.45,0,0,1,.1-.64,3.37,3.37,0,0,1,.31-.21l.21-.12a20.58,20.58,0,0,1-4.89-9.69,9.47,9.47,0,0,1-.16-3.2c.41-3,2.33-4.64,5.57-4.64s5.16,1.61,5.56,4.64a9.22,9.22,0,0,1-.16,3.2A20.57,20.57,0,0,1,468.25,524.44Zm4.14-12.8c-.35-2.58-1.86-3.84-4.63-3.84s-4.29,1.26-4.64,3.84a8.43,8.43,0,0,0,.15,2.89,20.16,20.16,0,0,0,4.49,9.07,20.29,20.29,0,0,0,4.48-9.07A8.43,8.43,0,0,0,472.39,511.64Zm-4.63,4a3.4,3.4,0,1,1,3.46-3.39A3.43,3.43,0,0,1,467.76,515.62Zm0-5.86a2.47,2.47,0,1,0,2.51,2.47A2.5,2.5,0,0,0,467.76,509.76Z"
                transform="translate(-454.68 -506.88)"
            />
        </svg>
    </Tooltip>
);

export const MapIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30">
        <path
            d="M458.37,527.71h-.05a.47.47,0,0,1-.47-.42,2.44,2.44,0,0,1,0-.27v-.16a3.52,3.52,0,0,1,.1-.65.47.47,0,0,1,.58-.33.46.46,0,0,1,.33.57,2.34,2.34,0,0,0-.07.45V527a1.09,1.09,0,0,0,0,.18A.47.47,0,0,1,458.37,527.71Zm2-2.55h-.19a1.33,1.33,0,0,0-.43.13.46.46,0,0,1-.22.06.49.49,0,0,1-.42-.24.47.47,0,0,1,.19-.63,2.09,2.09,0,0,1,.78-.24,1.89,1.89,0,0,1,.41,0,.46.46,0,0,1,.41.52A.45.45,0,0,1,460.33,525.16Zm.17,3.86a3.25,3.25,0,0,1-.44,0l-.36,0a1.55,1.55,0,0,1-.31-.06.46.46,0,1,1,.23-.89l.19,0a2.18,2.18,0,0,0,.57,0,.47.47,0,0,1,.53.4A.46.46,0,0,1,460.5,529Zm16.44-8.68a.49.49,0,0,1,.61.28,1.77,1.77,0,0,1,.12.64s0,.08,0,.12a2.41,2.41,0,0,1-.08.44.48.48,0,0,1-.45.33.32.32,0,0,1-.14,0,.45.45,0,0,1-.31-.57,1,1,0,0,0,0-.24v0a.87.87,0,0,0-.06-.32A.47.47,0,0,1,476.94,520.34Zm-1.83,2.75a1.65,1.65,0,0,0,.64-.24l0,0a.48.48,0,0,1,.66.09.47.47,0,0,1-.09.65l-.07,0a2.56,2.56,0,0,1-1,.4h-.1a.46.46,0,0,1-.46-.37A.47.47,0,0,1,475.11,523.09Zm-.82-3.18a.46.46,0,0,1,.32-.57,2.87,2.87,0,0,1,1.13-.08.46.46,0,0,1,.4.52.47.47,0,0,1-.53.4,1.69,1.69,0,0,0-.74.05l-.13,0A.47.47,0,0,1,474.29,519.91Zm-19.61,11.45L456.52,517h5.13a.47.47,0,1,1,0,.93h-4.3l-1.6,12.47h23.8L478.18,518H473.9a.47.47,0,1,1,0-.93H479l1.57,14.32Zm18.63-8.11a.5.5,0,0,1,.5.44.46.46,0,0,1-.45.48l-.95,0h0a.46.46,0,1,1,0-.92Zm-2.85.17a.46.46,0,1,1,.11.92c-.31,0-.61.09-.89.15h-.1a.48.48,0,0,1-.46-.37.47.47,0,0,1,.37-.55C469.79,523.52,470.12,523.47,470.46,523.42ZM465.91,526a.46.46,0,0,1-.09.65c-.26.19-.53.38-.8.55a.48.48,0,0,1-.26.07.46.46,0,0,1-.39-.21.44.44,0,0,1,.13-.63c.26-.16.51-.34.75-.52A.48.48,0,0,1,465.91,526Zm-2.37,1.52a.46.46,0,0,1-.22.61c-.3.14-.6.26-.9.38a.51.51,0,0,1-.17,0,.48.48,0,0,1-.44-.3.47.47,0,0,1,.27-.6c.28-.1.56-.22.84-.35A.46.46,0,0,1,463.54,527.5Zm4.71-3.06h0a.45.45,0,0,1-.21.59,3.72,3.72,0,0,0-.48.27l-.26.17a.47.47,0,0,1-.28.09.49.49,0,0,1-.38-.19.45.45,0,0,1,.1-.64,3.37,3.37,0,0,1,.31-.21l.21-.12a20.58,20.58,0,0,1-4.89-9.69,9.47,9.47,0,0,1-.16-3.2c.41-3,2.33-4.64,5.57-4.64s5.16,1.61,5.56,4.64a9.22,9.22,0,0,1-.16,3.2A20.57,20.57,0,0,1,468.25,524.44Zm4.14-12.8c-.35-2.58-1.86-3.84-4.63-3.84s-4.29,1.26-4.64,3.84a8.43,8.43,0,0,0,.15,2.89,20.16,20.16,0,0,0,4.49,9.07,20.29,20.29,0,0,0,4.48-9.07A8.43,8.43,0,0,0,472.39,511.64Zm-4.63,4a3.4,3.4,0,1,1,3.46-3.39A3.43,3.43,0,0,1,467.76,515.62Zm0-5.86a2.47,2.47,0,1,0,2.51,2.47A2.5,2.5,0,0,0,467.76,509.76Z"
            transform="translate(-454.68 -506.88)"
        />
    </svg>
);

export const CheckMark = () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20.42 20.58">
        <path
            d="M467.25,529.68a10.29,10.29,0,1,1,10.21-10.29A10.26,10.26,0,0,1,467.25,529.68Zm0-19.79a9.5,9.5,0,1,0,9.42,9.5A9.47,9.47,0,0,0,467.25,509.89Zm-.89,12.93a.36.36,0,0,1-.29.13.46.46,0,0,1-.25-.08l-3.92-3.17a.4.4,0,0,1-.06-.56.39.39,0,0,1,.55-.06L466,522l6-6.84a.38.38,0,0,1,.55,0,.4.4,0,0,1,0,.56Z"
            transform="translate(-457.04 -509.1)"
        />
    </svg>
);

export const UserNetwork = () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25.92 20.58">
        <path
            d="M480.11,529.74H471.8a.49.49,0,0,1-.49-.49c0-2.36,1.78-3.81,4.64-3.81s4.65,1.46,4.65,3.81A.49.49,0,0,1,480.11,529.74ZM476,526.41c-.8,0-3.31.18-3.63,2.36h7.27C479.26,526.59,476.76,526.41,476,526.41Zm0-1.46a2.31,2.31,0,1,1,2.33-2.31A2.31,2.31,0,0,1,476,525Zm0-3.64a1.34,1.34,0,1,0,1.35,1.33A1.33,1.33,0,0,0,476,521.31Zm-4.15-2.74h-8.32a.49.49,0,0,1-.49-.49c0-2.36,1.78-3.82,4.65-3.82s4.65,1.46,4.65,3.82A.49.49,0,0,1,471.8,518.57Zm-4.16-3.34c-.8,0-3.31.18-3.63,2.36h7.26C471,515.41,468.44,515.23,467.64,515.23Zm0-1.45a2.31,2.31,0,1,1,2.32-2.31A2.33,2.33,0,0,1,467.64,513.78Zm0-3.65a1.34,1.34,0,1,0,1.34,1.34A1.34,1.34,0,0,0,467.64,510.13Zm-4.16,19.61h-8.31a.49.49,0,0,1-.49-.49c0-2.36,1.78-3.81,4.65-3.81s4.64,1.46,4.64,3.81A.49.49,0,0,1,463.48,529.74Zm-4.15-3.33c-.81,0-3.31.18-3.64,2.36H463C462.64,526.59,460.13,526.41,459.33,526.41Zm0-1.46a2.31,2.31,0,1,1,2.32-2.31A2.32,2.32,0,0,1,459.33,525Zm0-3.64a1.34,1.34,0,1,0,1.34,1.33A1.33,1.33,0,0,0,459.33,521.31Zm7.82,1.25v-2.87a.49.49,0,0,1,1,0v2.87l2,2a.49.49,0,0,1,0,.64.5.5,0,0,1-.69,0l-1.84-1.83-1.84,1.83a.49.49,0,0,1-.69-.69Z"
            transform="translate(-454.68 -509.16)"
        />
    </svg>
);

export const Truck = () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22.78 15.88">
        <path
            d="M477.53,514.65a4,4,0,0,0-3-1.29H471.4v-1.78a.58.58,0,0,0-.57-.58H456.57a.58.58,0,0,0-.57.57h0v12.81a.58.58,0,0,0,.56.58h2.29a2.25,2.25,0,0,0,4.44,0h8.77a2.24,2.24,0,0,0,4.43,0h1.71a.58.58,0,0,0,.57-.57h0v-6A5.35,5.35,0,0,0,477.53,514.65Zm-20.39-2.49h13.09v11.62h-7a2.24,2.24,0,0,0-4.24,0h-1.81Zm3.93,13.51a1.13,1.13,0,1,1,1.11-1.15v0a1.12,1.12,0,0,1-1.11,1.13Zm13.2,0a1.13,1.13,0,1,1,1.11-1.15v0a1.12,1.12,0,0,1-1.11,1.13Zm3.35-1.9h-1.23a2.24,2.24,0,0,0-4.23,0h-.78v-9.25h3.12c1.93,0,3.13,1.47,3.13,3.83v5.42Z"
            transform="translate(-456 -511)"
        />
    </svg>
);

export const World = () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21.6 21.6">
        <path
            d="M475.27,511.73a10.77,10.77,0,1,0,3.17,7.63A10.67,10.67,0,0,0,475.27,511.73Zm2.19,7.15h-4.19a18.76,18.76,0,0,0-.68-4.7,11.18,11.18,0,0,0,2.23-1.53A9.81,9.81,0,0,1,477.46,518.88Zm-9.34,1h4.19a18.23,18.23,0,0,1-.61,4.32,11.14,11.14,0,0,0-3.58-.78Zm6-7.87a10,10,0,0,1-1.83,1.28,12.37,12.37,0,0,0-.57-1.33,7.84,7.84,0,0,0-1.42-2A9.87,9.87,0,0,1,474.12,512Zm-6-2.29a4.53,4.53,0,0,1,2.73,2.67,10.32,10.32,0,0,1,.56,1.31,9.91,9.91,0,0,1-3.29.74Zm3.58,4.91a17.56,17.56,0,0,1,.6,4.29h-4.18v-3.51A11.08,11.08,0,0,0,471.7,514.59Zm-4.54,4.29H463a17.48,17.48,0,0,1,.61-4.29,10.76,10.76,0,0,0,3.57.77v3.52Zm0-9.2v4.72a9.86,9.86,0,0,1-3.29-.74,10.32,10.32,0,0,1,.56-1.31A4.53,4.53,0,0,1,467.16,509.68Zm-2.18.22a8,8,0,0,0-1.42,2c-.2.42-.39.86-.57,1.33a10.38,10.38,0,0,1-1.83-1.28A9.87,9.87,0,0,1,465,509.9Zm-4.52,2.75a11.18,11.18,0,0,0,2.23,1.53,18.38,18.38,0,0,0-.68,4.7h-4.19A9.81,9.81,0,0,1,460.46,512.65Zm-2.64,7.19H462a18.61,18.61,0,0,0,.69,4.73,10.41,10.41,0,0,0-2.22,1.52A9.81,9.81,0,0,1,457.82,519.84Zm3.36,6.93A9.44,9.44,0,0,1,463,525.5c.17.45.36.89.56,1.3a8.08,8.08,0,0,0,1.42,2A9.9,9.9,0,0,1,461.18,526.77Zm6,2.27a4.53,4.53,0,0,1-2.73-2.67,9.86,9.86,0,0,1-.55-1.28,9.86,9.86,0,0,1,3.28-.74V529Zm-3.58-4.88a18.23,18.23,0,0,1-.61-4.32h4.19v3.54A10.88,10.88,0,0,0,463.58,524.16Zm4.54,4.88v-4.69a9.86,9.86,0,0,1,3.28.74,9.86,9.86,0,0,1-.55,1.28A4.53,4.53,0,0,1,468.12,529Zm2.18-.22a7.9,7.9,0,0,0,1.42-2,13.9,13.9,0,0,0,.56-1.29,9.39,9.39,0,0,1,1.82,1.26A9.64,9.64,0,0,1,470.3,528.82Zm4.5-2.73a11,11,0,0,0-2.21-1.52,19.06,19.06,0,0,0,.69-4.73h4.19A9.87,9.87,0,0,1,474.8,526.09Z"
            transform="translate(-456.84 -508.56)"
        />
    </svg>
);

export const ArrowDown = () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 7.2 4.32">
        <path
            d="M467.4,521.64l-3.09-3.25a.54.54,0,0,1,0-.75.48.48,0,0,1,.71,0l2.74,2.88,2.74-2.88a.48.48,0,0,1,.71,0,.54.54,0,0,1,0,.75l-3.09,3.25a.48.48,0,0,1-.72,0Z"
            transform="translate(-464.16 -517.48)"
        />
    </svg>
);

export const ArrowUp = () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 7.2 4.32">
        <path
            d="M468.12,517.64l3.09,3.25a.54.54,0,0,1,0,.75.48.48,0,0,1-.71,0l-2.74-2.88L465,521.64a.48.48,0,0,1-.71,0,.54.54,0,0,1,0-.75l3.09-3.25a.49.49,0,0,1,.72,0Z"
            transform="translate(-464.16 -517.48)"
        />
    </svg>
);

export const ArrowLeft = () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 4.32 7.2">
        <path
            d="M465.76,519.28l3.25-3.09a.54.54,0,0,1,.75,0,.48.48,0,0,1,0,.71l-2.88,2.74,2.88,2.74a.48.48,0,0,1,0,.71.54.54,0,0,1-.75,0L465.76,520a.48.48,0,0,1,0-.72Z"
            transform="translate(-465.6 -516.04)"
        />
    </svg>
);

export const ArrowRight = () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 4.32 7.2">
        <path
            d="M469.76,520l-3.25,3.09a.54.54,0,0,1-.75,0,.48.48,0,0,1,0-.71l2.88-2.74-2.88-2.74a.48.48,0,0,1,0-.71.54.54,0,0,1,.75,0l3.25,3.09a.49.49,0,0,1,0,.72Z"
            transform="translate(-465.6 -516.04)"
        />
    </svg>
);

export const Close = () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 59.18 56.24">
        <path
            d="M386.84,618.12l22.52-21.4a3.8,3.8,0,0,0,0-5.57,4.31,4.31,0,0,0-5.86,0L381,612.54l-22.51-21.38a4.27,4.27,0,0,0-5.86,0,3.79,3.79,0,0,0,0,5.56l22.52,21.4-22.53,21.4a3.82,3.82,0,0,0,0,5.57,4.33,4.33,0,0,0,5.87,0L381,623.7l22.51,21.38a4.29,4.29,0,0,0,5.86,0,3.79,3.79,0,0,0,0-5.56Z"
            transform="translate(-351.4 -590)"
        />
    </svg>
);

export const Building = () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 30">
        <path d="M29.5,30H.5a.5.5,0,0,1,0-1H5V.5A.5.5,0,0,1,5.5,0h13a.5.5,0,0,1,.5.5V12h7a.5.5,0,0,1,.5.5V29h3a.5.5,0,0,1,0,1Zm-21-1h2V24.5A.5.5,0,0,0,10,24H9a.5.5,0,0,0-.5.5ZM18,1H6V29H7.5V24.5A1.5,1.5,0,0,1,9,23h1a1.5,1.5,0,0,1,1.5,1.5V29h1V12.5A.5.5,0,0,1,13,12h5Zm7.5,12h-12V29h12Zm-10,1h3a.5.5,0,0,1,.5.5v3a.5.5,0,0,1-.5.5h-3a.5.5,0,0,1-.5-.5v-3A.5.5,0,0,1,15.5,14Zm.5,3h2V15H16Zm-.5,2h3a.5.5,0,0,1,.5.5v3a.5.5,0,0,1-.5.5h-3a.5.5,0,0,1-.5-.5v-3A.5.5,0,0,1,15.5,19Zm.5,3h2V20H16Zm-.5,2h3a.5.5,0,0,1,.5.5v3a.5.5,0,0,1-.5.5h-3a.5.5,0,0,1-.5-.5v-3A.5.5,0,0,1,15.5,24Zm.5,3h2V25H16Zm4.5-13h3a.5.5,0,0,1,.5.5v3a.5.5,0,0,1-.5.5h-3a.5.5,0,0,1-.5-.5v-3A.5.5,0,0,1,20.5,14Zm.5,3h2V15H21Zm-.5,2h3a.5.5,0,0,1,.5.5v3a.5.5,0,0,1-.5.5h-3a.5.5,0,0,1-.5-.5v-3A.5.5,0,0,1,20.5,19Zm.5,3h2V20H21Zm-.5,2h3a.5.5,0,0,1,.5.5v3a.5.5,0,0,1-.5.5h-3a.5.5,0,0,1-.5-.5v-3A.5.5,0,0,1,20.5,24Zm.5,3h2V25H21ZM12.5,10.5v-3A.5.5,0,0,1,13,7h3a.5.5,0,0,1,.5.5v3a.5.5,0,0,1-.5.5H13A.5.5,0,0,1,12.5,10.5Zm1-.5h2V8h-2ZM16,6H13a.5.5,0,0,1-.5-.5v-3A.5.5,0,0,1,13,2h3a.5.5,0,0,1,.5.5v3A.5.5,0,0,1,16,6Zm-.5-3h-2V5h2ZM11,21H8a.5.5,0,0,1-.5-.5v-3A.5.5,0,0,1,8,17h3a.5.5,0,0,1,.5.5v3A.5.5,0,0,1,11,21Zm-.5-3h-2v2h2Zm.5-2H8a.5.5,0,0,1-.5-.5v-3A.5.5,0,0,1,8,12h3a.5.5,0,0,1,.5.5v3A.5.5,0,0,1,11,16Zm-.5-3h-2v2h2Zm.5-2H8a.5.5,0,0,1-.5-.5v-3A.5.5,0,0,1,8,7h3a.5.5,0,0,1,.5.5v3A.5.5,0,0,1,11,11Zm-.5-3h-2v2h2ZM11,6H8a.5.5,0,0,1-.5-.5v-3A.5.5,0,0,1,8,2h3a.5.5,0,0,1,.5.5v3A.5.5,0,0,1,11,6Zm-.5-3h-2V5h2Z" />
    </svg>
);

export const Document = () => (
    <Tooltip placement="right" title={<FormattedMessage id="sideMenu.hoverMessages.Rapports" />}>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 23 28">
            <path
                d="M25.8,29H4.2a.7.7,0,0,1-.7-.7V1.7A.7.7,0,0,1,4.2,1H25.8a.7.7,0,0,1,.7.7V28.3A.7.7,0,0,1,25.8,29ZM4.5,28h21V2H4.5Z"
                transform="translate(-3.5 -1)"
            />
            <rect x="4.56" y="6.5" width="13.87" height="1" />
            <rect className="cls-1" x="4.56" y="10.5" width="13.87" height="1" />
            <rect className="cls-1" x="4.56" y="14.5" width="13.87" height="1" />
        </svg>
    </Tooltip>
);

export const Geofence = () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28 28">
        <image
            id="image0"
            width="28"
            height="28"
            x="0"
            y="0"
            href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAQAAADYBBcfAAAABGdBTUEAALGPC/xhBQAAACBjSFJN
            AAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAAmJLR0QA/4ePzL8AAAAJcEhZ
            cwAADdcAAA3XAUIom3gAAAAHdElNRQfjCh4OFxXEsrb2AAABw0lEQVQ4y52UPU8UURSGn7sMC4iF
            8pGYKCZss0biEiAsxULFJmKFoaDZQu2sxdof4B+wtTAmNsZCKqCjoGAhNNoIBoICMTa6LISJ+1rM
            t8vszPpW5565zz0f98w1pJCWuOmaNfMiDeGBG/L0xfNlUpEdvmU8w2oZyWKSWWaZaP5mAWiGEXfd
            4LW5AOUoU6bMdWCPnwxcCrLEvLs+o1MFHjAE/GCVVVbMV1XpxqKbepCqk9J7hfVby3qmgvxNuqGc
            5iU91624Gm0qfDB21GmOQcc0GDSHcV212fwXc+E6+9wN1g7YmepSPoVBp4YxLWhNp1rQQ8Ueopf6
            o95m9zt9ax1QjyX5NxrU2EstMVWCZMPgaSKoy8CrSaCpcfB/ESN9bRfM6YpjOkM+Sp4+BrQIfDT1
            FmCGPNtBo9+GJnU8PqCmJFXCqTYSk3T0Oehr8wtQUUk9MX39xWFk7PRGUdna0is90YhCB2tN+zqX
            rQPtqsv5rcLzOUeWEtM84ilQ0w5VqqybPeA2AEOckDEAukfeB5fNGYAs8kxQYpo7ZIAjsvS7e04Y
            NiRK1yhSpMh9sgGYsp1ujZ6+q8dqg1zHfziw2+Ci+gsFK9bp+XqjuAAAACV0RVh0ZGF0ZTpjcmVh
            dGUAMjAxOS0xMC0zMFQxNDoyMzoyMSswMzowMPrlV8gAAAAldEVYdGRhdGU6bW9kaWZ5ADIwMTkt
            MTAtMzBUMTQ6MjM6MjErMDM6MDCLuO90AAAAAElFTkSuQmCC"
        />
    </svg>
);
export const DocumentPencil = () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 26 26">
        <path
            data-name="7svxa"
            d="M25.33,11.41l-5.52,5.53v6.77A2.3,2.3,0,0,1,17.52,26H2.29A2.28,2.28,0,0,1,0,23.71V2.29A2.28,2.28,0,0,1,2.29,0H15.37A2.26,2.26,0,0,1,17,.67l2.16,2.15a2.29,2.29,0,0,1,.67,1.62v6l2.29-2.3a2.28,2.28,0,0,1,3.23,3.23ZM13.71,5.33V1.52H2.29a.76.76,0,0,0-.77.76V23.71a.78.78,0,0,0,.77.77H17.52a.77.77,0,0,0,.76-.77V18.46l-.09.1a.83.83,0,0,1-.3.18l-3.23,1.08a.76.76,0,0,1-1-.48.66.66,0,0,1,0-.48l1.07-3.24a.7.7,0,0,1,.19-.29L16,14.25,18.28,12V6.09H14.47a.76.76,0,0,1-.76-.76Zm3.94,11.61-1.08-1.07-.41.41-.54,1.61,1.62-.54Zm.41-13L15.91,1.75a.84.84,0,0,0-.67-.23V4.57h3a.84.84,0,0,0-.22-.67Zm3.25,7.22-3.66,3.67,1.08,1.07,3.66-3.66Zm2.94-1.86a.75.75,0,0,0-1.07,0l-.79.78,1.08,1.08.78-.78a.76.76,0,0,0,0-1.08Zm-9.78-.12H3.81a.76.76,0,0,1,0-1.52H14.47a.76.76,0,1,1,0,1.52ZM3.81,10.66h7.62a.77.77,0,0,1,0,1.53H3.81a.77.77,0,0,1,0-1.53Zm0,3.05h7.62a.76.76,0,0,1,.73.79.75.75,0,0,1-.73.73H3.81a.76.76,0,0,1,0-1.52Zm0,3.05h7.62a.76.76,0,0,1,.79.73.77.77,0,0,1-.74.79H3.81a.76.76,0,0,1,0-1.52ZM9.9,21.43h4.57a.76.76,0,1,1,0,1.52H9.9a.76.76,0,1,1,0-1.52Z"
            transform="translate(0)"
        />
    </svg>
);

export const Settings = () => (
    <Tooltip
        placement="right"
        title={<FormattedMessage id="sideMenu.hoverMessages.Administration" />}
    >
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28.01 28">
            <path
                d="M26.56,16.94l-2,.33a10.88,10.88,0,0,1-.79,1.9L25,20.8A1.74,1.74,0,0,1,24.77,23L23,24.77A1.72,1.72,0,0,1,20.8,25L19.18,23.8a10.88,10.88,0,0,1-1.9.79l-.34,2A1.73,1.73,0,0,1,15.24,28H12.76a1.71,1.71,0,0,1-1.7-1.44l-.33-2a11.07,11.07,0,0,1-1.85-.76L7.24,25A1.72,1.72,0,0,1,5,24.81L3.27,23.07a1.73,1.73,0,0,1-.19-2.23l1.15-1.6a11.26,11.26,0,0,1-.8-1.9l-2-.34A1.73,1.73,0,0,1,0,15.29V12.83a1.72,1.72,0,0,1,1.44-1.71l2-.33a10.9,10.9,0,0,1,.77-1.91L3,7.24A1.73,1.73,0,0,1,3.2,5L4.94,3.26a1.72,1.72,0,0,1,1.22-.5,1.59,1.59,0,0,1,1,.32L8.78,4.23a10.61,10.61,0,0,1,1.9-.8l.34-2A1.73,1.73,0,0,1,12.72,0h2.47a1.7,1.7,0,0,1,1.7,1.44l.33,2a10.69,10.69,0,0,1,2,.81L20.83,3a1.72,1.72,0,0,1,2.22.19L24.79,5A1.73,1.73,0,0,1,25,7.2L23.82,8.82a11.75,11.75,0,0,1,.8,1.9l2,.34A1.7,1.7,0,0,1,28,12.76v2.47a1.7,1.7,0,0,1-1.44,1.7Zm-.12-4.17a.15.15,0,0,0-.13-.15l-2.46-.42a.78.78,0,0,1-.63-.58,9.41,9.41,0,0,0-1-2.45.79.79,0,0,1,0-.86l1.44-2a.17.17,0,0,0,0-.2L21.92,4.34a.14.14,0,0,0-.1,0,.17.17,0,0,0-.1,0l-2,1.45a.79.79,0,0,1-.86,0,9.49,9.49,0,0,0-2.51-1,.79.79,0,0,1-.59-.64l-.4-2.44a.15.15,0,0,0-.16-.13H12.73a.15.15,0,0,0-.15.13l-.43,2.48a.78.78,0,0,1-.57.63,9.1,9.1,0,0,0-2.45,1,.81.81,0,0,1-.87,0l-2-1.44a.17.17,0,0,0-.1,0,.15.15,0,0,0-.1,0L4.3,6.12a.17.17,0,0,0,0,.2l1.45,2a.75.75,0,0,1,0,.85,9.56,9.56,0,0,0-1,2.46.81.81,0,0,1-.63.59l-2.44.4a.15.15,0,0,0-.13.16v2.46a.14.14,0,0,0,.13.15l2.47.42a.81.81,0,0,1,.63.58,9.79,9.79,0,0,0,1,2.45.79.79,0,0,1,0,.86l-1.44,2a.17.17,0,0,0,0,.2l1.74,1.74a.17.17,0,0,0,.11.05l.09,0,2.05-1.46a.79.79,0,0,1,.85,0,9.5,9.5,0,0,0,2.4,1,.78.78,0,0,1,.58.63l.4,2.45a.16.16,0,0,0,.16.13h2.46a.14.14,0,0,0,.15-.13l.42-2.45a.77.77,0,0,1,.58-.63,9.41,9.41,0,0,0,2.45-1,.79.79,0,0,1,.86,0l2,1.45a.19.19,0,0,0,.09,0,.11.11,0,0,0,.1-.05l1.75-1.74a.17.17,0,0,0,0-.2l-1.45-2a.79.79,0,0,1,0-.86,9.41,9.41,0,0,0,1-2.45.78.78,0,0,1,.63-.58l2.45-.4a.15.15,0,0,0,.13-.16ZM14,20a6.05,6.05,0,1,1,6.06-6A6.05,6.05,0,0,1,14,20Zm0-10.5a4.47,4.47,0,1,0-.42,8.93,2.94,2.94,0,0,0,.42,0,4.47,4.47,0,0,0,0-8.94Z"
                transform="translate(0)"
            />
        </svg>
    </Tooltip>
);
export const Carburant = () => (
    <Tooltip
        placement="right"
        title={<FormattedMessage id="sideMenu.hoverMessages.GestionDeCarburant" />}
    >
        <svg
            version="1.0"
            xmlns="http://www.w3.org/2000/svg"
            width="30.000000pt"
            height="45pt"
            weight="200"
            viewBox="0 0 225.000000 225.000000"
            preserveAspectRatio="xMidYMid meet"
        >
            <g
                transform="translate(0.000000,225.000000) scale(0.100000,-0.100000)"
                fill="#000000"
                stroke="none"
                strokeWidth="2"
            >
                <path
                    d="M1055 1948 c-20 -20 -97 -144 -186 -303 -135 -240 -204 -363 -329
            -585 -20 -36 -69 -121 -107 -190 -39 -69 -110 -192 -157 -274 -47 -82 -91
            -167 -98 -187 -14 -48 2 -91 40 -109 21 -9 225 -12 901 -11 949 2 920 0 941
            56 5 14 7 39 3 56 -10 50 -848 1509 -888 1547 -20 18 -45 32 -60 32 -15 0 -40
            -13 -60 -32z m148 -305 c41 -71 121 -209 179 -308 57 -99 196 -337 307 -528
            111 -191 201 -355 199 -365 -3 -16 -56 -17 -771 -20 -718 -2 -767 -1 -767 15
            0 9 98 188 217 398 120 209 223 390 229 402 18 32 263 463 286 501 11 17 26
            32 33 32 7 0 47 -57 88 -127z"
                />
                <path
                    d="M890 1220 c-19 -19 -20 -33 -20 -380 l0 -360 160 0 160 0 0 200 0
            200 39 0 c26 0 41 -5 45 -16 3 -9 6 -88 6 -175 0 -88 4 -168 10 -178 17 -33
            62 -44 103 -27 50 20 53 45 28 200 -14 85 -21 175 -21 256 l0 126 -63 62 c-34
            34 -68 62 -75 62 -20 0 -14 -25 13 -50 21 -20 25 -33 25 -81 0 -62 16 -89 51
            -89 18 0 19 -8 18 -117 0 -73 5 -146 15 -191 9 -40 16 -86 16 -102 0 -36 -30
            -56 -60 -40 -19 10 -20 21 -20 170 0 153 -8 206 -33 222 -7 4 -31 8 -54 8
            l-43 0 0 138 c0 132 -1 140 -23 160 -21 20 -34 22 -140 22 -104 0 -119 -2
            -137 -20z m250 -125 l0 -96 -112 3 -113 3 -3 79 c-2 44 -1 85 2 93 4 10 33 13
            116 13 l110 0 0 -95z m220 -71 c0 -31 -2 -35 -15 -24 -8 7 -15 23 -15 36 0 15
            6 24 15 24 11 0 15 -11 15 -36z"
                />
            </g>
        </svg>
    </Tooltip>
);
export const Calendar = () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25 26">
        <path
            d="M24.55,26H.45A.44.44,0,0,1,0,25.57V2.17a.45.45,0,0,1,.45-.44H3.57V.43A.44.44,0,0,1,4,0H7.14a.44.44,0,0,1,.45.43h0v1.3h9.82V.43A.44.44,0,0,1,17.86,0H21a.44.44,0,0,1,.45.43h0v1.3h3.12a.44.44,0,0,1,.45.44v23.4a.44.44,0,0,1-.45.43ZM6.7.87H4.46v2.6H6.7Zm13.84,0H18.3v2.6h2.24ZM24.11,2.6H21.43V3.9a.44.44,0,0,1-.45.43H17.86a.43.43,0,0,1-.45-.43V2.6H7.59V3.9a.44.44,0,0,1-.45.43H4a.44.44,0,0,1-.45-.43h0V2.6H.89V6.5H24.11Zm0,4.77H.89V25.13H24.11ZM21,10V22.53H4V10Zm-4,11.7h3.13v-3H17Zm0-3.9h3.13v-3H17Zm0-3.9h3.13v-3H17Zm-4,7.8h3.12v-3H13Zm0-3.9h3.12v-3H13Zm0-3.9h3.12v-3H13Zm-4,7.8h3.12v-3H8.93Zm0-3.9h3.12v-3H8.93Zm0-3.9h3.12v-3H8.93Zm-4,7.8H8v-3H4.91Zm0-3.9H8v-3H4.91Zm0-3.9H8v-3H4.91Z"
            transform="translate(0 0)"
        />
    </svg>
);

export const FullArrowDown = () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 7.2 4.32">
        <path
            d="M889.65,517a.48.48,0,0,0-.36-.16h-6.18a.48.48,0,0,0-.36.16.54.54,0,0,0,0,.75l3.09,3.25a.49.49,0,0,0,.72,0l3.09-3.25A.54.54,0,0,0,889.65,517Z"
            transform="translate(-882.6 -516.8)"
        />
    </svg>
);

export const FullArrowUp = () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 7.2 4.32">
        <path
            d="M882.75,521a.51.51,0,0,0,.36.15h6.18a.51.51,0,0,0,.36-.15.56.56,0,0,0,0-.76L886.56,517a.48.48,0,0,0-.72,0l-3.09,3.25A.56.56,0,0,0,882.75,521Z"
            transform="translate(-882.6 -516.8)"
        />
    </svg>
);

export const FullArrowLeft = () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 4.32 7.2">
        <path
            d="M888.2,522.41a.48.48,0,0,0,.16-.36v-6.18a.48.48,0,0,0-.16-.36.54.54,0,0,0-.75,0l-3.25,3.09a.48.48,0,0,0,0,.72l3.25,3.09A.54.54,0,0,0,888.2,522.41Z"
            transform="translate(-884.04 -515.36)"
        />
    </svg>
);

export const FullArrowRight = () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 4.32 7.2">
        <path
            d="M884.2,515.51a.48.48,0,0,0-.16.36v6.18a.48.48,0,0,0,.16.36.54.54,0,0,0,.75,0l3.25-3.09a.49.49,0,0,0,0-.72L885,515.51A.54.54,0,0,0,884.2,515.51Z"
            transform="translate(-884.04 -515.36)"
        />
    </svg>
);

export const ArrowSelection = () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 4.9 7.92">
        <path
            d="M891.43,521.07a.31.31,0,0,0,.24.1h4.21a.35.35,0,0,0,.25-.1.38.38,0,0,0,0-.51L894,518.34a.35.35,0,0,0-.24-.11.36.36,0,0,0-.25.11l-2.1,2.22A.36.36,0,0,0,891.43,521.07Z"
            transform="translate(-891.33 -518.23)"
        />
        <path
            className="cls-1"
            d="M896.13,523.32a.36.36,0,0,0-.25-.11h-4.21a.32.32,0,0,0-.24.11.36.36,0,0,0,0,.51l2.1,2.22a.35.35,0,0,0,.25.1.34.34,0,0,0,.24-.1l2.11-2.22A.38.38,0,0,0,896.13,523.32Z"
            transform="translate(-891.33 -518.23)"
        />
    </svg>
);

export const StatusDanger = () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17 21.52">
        <path
            d="M959.89,529.41c-6.57,0-6.71,7.68-8.5,7.68v1.16h.91c0,.56,0,1.3,0,2v.61c0,5.53,3.4,10,7.57,10s7.58-4.49,7.58-10v-.6c0-.82,0-1.51,0-2.06h.9v-1.16C966.61,537.09,966.46,529.41,959.89,529.41Zm-1.24,8.8c2.74,0,5.77,0,7.84,0,0,.21,0,.42,0,.63H953.3v-.63Zm5.51,2.7v1.38h-2.7v-1.38Zm-5.83,0v1.38h-2.7v-1.38Zm1.56,9c-2.8,0-5.19-2.42-6.13-5.81H966C965.09,547.51,962.7,549.93,959.89,549.93Z"
            transform="translate(-951.39 -529.41)"
        />
    </svg>
);

export const StatusNoSignal = () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21.6 21.6">
        <path
            d="M900.43,512.11,880.53,533a.5.5,0,0,0,0,.67h.64l2.28-2.39a11.16,11.16,0,0,0,1.65,1.49.42.42,0,0,0,.26.08.45.45,0,0,0,.37-.2.49.49,0,0,0-.12-.66,11.16,11.16,0,0,1-1.53-1.38l1.28-1.34a8.26,8.26,0,0,0,1.27,1.16.39.39,0,0,0,.25.08.44.44,0,0,0,.37-.2.5.5,0,0,0-.11-.66,6.7,6.7,0,0,1-1.14-1l1.27-1.34a4.61,4.61,0,0,0,.88.83.43.43,0,0,0,.26.09.44.44,0,0,0,.37-.21.49.49,0,0,0-.12-.66,4.27,4.27,0,0,1-.76-.71l1.91-2a1.73,1.73,0,0,0,1.39.71,1.85,1.85,0,0,0,1.8-1.89,1.92,1.92,0,0,0-.68-1.47l1.91-2a4.84,4.84,0,0,1-.49,7.36.49.49,0,0,0-.12.66.44.44,0,0,0,.63.12,5.83,5.83,0,0,0,.62-8.82l1.27-1.33a7.77,7.77,0,0,1-.87,11.71.49.49,0,0,0-.12.66.43.43,0,0,0,.62.12,8.63,8.63,0,0,0,3.53-7,8.71,8.71,0,0,0-2.52-6.15L898,516a10.67,10.67,0,0,1-1.25,16,.49.49,0,0,0-.12.66.44.44,0,0,0,.63.12,11.66,11.66,0,0,0,1.38-17.5l2.38-2.5v-.67Zm-14.18,13.56.69-.73a5.07,5.07,0,0,1-.24-1.51,4.62,4.62,0,0,1,4.5-4.73,4.27,4.27,0,0,1,1.43.27l.71-.75a5.15,5.15,0,0,0-2.14-.47,5.55,5.55,0,0,0-5.4,5.68A5.85,5.85,0,0,0,886.25,525.67Zm-2,2.1.66-.69a7.77,7.77,0,0,1-.91-3.65,7.4,7.4,0,0,1,7.2-7.57,6.9,6.9,0,0,1,3.48.95l.65-.69a7.73,7.73,0,0,0-4.13-1.2,8.32,8.32,0,0,0-8.1,8.51A8.87,8.87,0,0,0,884.25,527.77Zm7-14.74a9.45,9.45,0,0,1,5.44,1.72l.65-.68a10.3,10.3,0,0,0-6.09-2,11.09,11.09,0,0,0-10.8,11.35,11.79,11.79,0,0,0,1.89,6.4l.66-.69a10.69,10.69,0,0,1-1.65-5.71A10.17,10.17,0,0,1,891.2,513Z"
            transform="translate(-880.4 -512.08)"
        />
    </svg>
);

export const StatusSuccess = () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 42.03 35">
        <g>
            <path d="M40.4,13.9c-1,0-2.4-1.9-3.2-4.2L35.4,4.2A6.47,6.47,0,0,0,29.8,0H12.4A6.47,6.47,0,0,0,6.8,4.2L5,9.7c-.8,2.3-2.2,4.2-3.2,4.2S0,15.9,0,18.3v6.6a4.52,4.52,0,0,0,2.8,4.2v4.1A1.77,1.77,0,0,0,4.5,35H8.1a1.79,1.79,0,0,0,1.8-1.8V29.4H32.1v3.8A1.79,1.79,0,0,0,33.9,35h3.6a1.71,1.71,0,0,0,1.7-1.8V29.1A4.52,4.52,0,0,0,42,24.9V18.3C42.2,15.8,41.4,13.9,40.4,13.9Zm-1.6,8.3A3.1,3.1,0,1,1,35.7,19,3.14,3.14,0,0,1,38.8,22.2Zm-29.1,0a3.14,3.14,0,0,1-3.1,3.2,3.2,3.2,0,0,1,0-6.4A3.08,3.08,0,0,1,9.7,22.2Zm.5-11.5c0-2.1,1.7-6.4,3.7-6.4H28.8c2.1,0,3.7,4.3,3.7,6.4a3.78,3.78,0,0,1-3.7,3.8H13.9A3.6,3.6,0,0,1,10.2,10.7Z" />
        </g>
    </svg>
);

export const StatusWarning = () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 19.75 22.53">
        <path
            d="M850.88,451.56l-1.59,1.95a7.41,7.41,0,0,1,2.87,4.05H838a7.35,7.35,0,0,1,5.62-5.23v2.87l6.32-4.17-6.32-4.17v2.91a9.88,9.88,0,1,0,7.31,1.79Zm-13.2,8.12a8,8,0,0,1,6.36,7.14A7.38,7.38,0,0,1,837.68,459.68Zm7.37,1.75a1.14,1.14,0,1,1,1.14-1.14A1.14,1.14,0,0,1,845.05,461.43Zm1,5.39a8,8,0,0,1,6.35-7.14A7.38,7.38,0,0,1,846.07,466.82Z"
            transform="translate(-835.17 -446.86)"
        />
    </svg>
);

export const StatusStopped = () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25 25">
        <path d="M17.66,0H7.34L0,7.34V17.66L7.34,25H17.66L25,17.66V7.34Z" />
    </svg>
);

export const Gear = () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28.01 28">
        <path
            d="M367.56,296.94l-2,.33a10.88,10.88,0,0,1-.79,1.9L366,300.8a1.74,1.74,0,0,1-.19,2.23L364,304.77a1.72,1.72,0,0,1-2.23.19l-1.62-1.16a10.88,10.88,0,0,1-1.9.79l-.34,2a1.73,1.73,0,0,1-1.7,1.44h-2.48a1.71,1.71,0,0,1-1.7-1.44l-.33-2a11.07,11.07,0,0,1-1.85-.76L348.24,305a1.72,1.72,0,0,1-2.22-.19l-1.75-1.74a1.73,1.73,0,0,1-.19-2.23l1.15-1.6a11.26,11.26,0,0,1-.8-1.9l-2-.34a1.73,1.73,0,0,1-1.44-1.71v-2.46a1.72,1.72,0,0,1,1.44-1.71l1.95-.33a10.9,10.9,0,0,1,.77-1.91L344,287.24a1.73,1.73,0,0,1,.2-2.23l1.74-1.75a1.72,1.72,0,0,1,1.22-.5,1.59,1.59,0,0,1,1,.32l1.62,1.15a10.61,10.61,0,0,1,1.9-.8l.34-2a1.73,1.73,0,0,1,1.7-1.44h2.47a1.7,1.7,0,0,1,1.7,1.44l.33,1.95a10.69,10.69,0,0,1,2,.81l1.63-1.16a1.72,1.72,0,0,1,2.22.19l1.74,1.74a1.73,1.73,0,0,1,.19,2.23l-1.16,1.62a11.75,11.75,0,0,1,.8,1.9l2,.34a1.7,1.7,0,0,1,1.43,1.7v2.47a1.7,1.7,0,0,1-1.44,1.7Zm-.12-4.17a.15.15,0,0,0-.13-.15l-2.46-.42a.78.78,0,0,1-.63-.58,9.41,9.41,0,0,0-1-2.45.79.79,0,0,1,0-.86l1.44-2a.17.17,0,0,0,0-.2l-1.75-1.74a.14.14,0,0,0-.1,0,.17.17,0,0,0-.1,0l-2,1.45a.79.79,0,0,1-.86,0,9.49,9.49,0,0,0-2.51-1,.79.79,0,0,1-.59-.64l-.4-2.44a.15.15,0,0,0-.16-.13h-2.46a.15.15,0,0,0-.15.13l-.43,2.48a.78.78,0,0,1-.57.63,9.1,9.1,0,0,0-2.45,1,.81.81,0,0,1-.87,0l-2-1.44a.17.17,0,0,0-.1,0,.15.15,0,0,0-.1.05l-1.75,1.74a.17.17,0,0,0,0,.2l1.45,2.05a.75.75,0,0,1,0,.85,9.56,9.56,0,0,0-1,2.46.81.81,0,0,1-.63.59l-2.44.4a.15.15,0,0,0-.13.16v2.46a.14.14,0,0,0,.13.15l2.47.42a.81.81,0,0,1,.63.58,9.79,9.79,0,0,0,1,2.45.79.79,0,0,1,0,.86l-1.44,2a.17.17,0,0,0,0,.2l1.74,1.74a.17.17,0,0,0,.11.05l.09,0,2.05-1.46a.79.79,0,0,1,.85,0,9.5,9.5,0,0,0,2.4,1,.78.78,0,0,1,.58.63l.4,2.45a.16.16,0,0,0,.16.13h2.46a.14.14,0,0,0,.15-.13l.42-2.45a.77.77,0,0,1,.58-.63,9.41,9.41,0,0,0,2.45-1,.79.79,0,0,1,.86,0l2,1.45a.19.19,0,0,0,.09,0,.11.11,0,0,0,.1,0l1.75-1.74a.17.17,0,0,0,0-.2l-1.45-2a.79.79,0,0,1,0-.86,9.41,9.41,0,0,0,1-2.45.78.78,0,0,1,.63-.58l2.45-.4a.15.15,0,0,0,.13-.16ZM355,300a6.05,6.05,0,1,1,6.06-6.05A6.05,6.05,0,0,1,355,300Zm0-10.5a4.47,4.47,0,1,0-.42,8.93H355a4.47,4.47,0,0,0,0-8.94Z"
            transform="translate(-341 -280)"
        />
    </svg>
);

export const ArrowLeaving = () => (
    <Tooltip placement="right" title={<FormattedMessage id="sideMenu.hoverMessages.Deconnexion" />}>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 26.44 28">
            <path
                d="M405.88,292h-12a2,2,0,0,0-2,2v7a1,1,0,0,0,2,0v-7h12v24h-12v-6a1,1,0,0,0-2,0v6a2,2,0,0,0,2,2h12a2,2,0,0,0,2-2V294A2,2,0,0,0,405.88,292Z"
                transform="translate(-381.44 -292)"
            />
            <path
                d="M384.86,307H401.4a1,1,0,0,0,0-2H384.86l3.78-3.79a1,1,0,0,0,0-1.41,1,1,0,0,0-1.41,0l-5.49,5.49a1,1,0,0,0-.22,1.09,1,1,0,0,0,.21.32h0l5.43,5.43a1,1,0,0,0,1.41,0,1,1,0,0,0,0-1.41Z"
                transform="translate(-381.44 -292)"
            />
        </svg>
    </Tooltip>
);

export const ArrowShare = () => (
    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 26.4 28">
        <path
            d="M0,2l0,24c0,1.1,0.9,2,2,2h12c1.1,0,2-0.9,2-2v-6c0-0.6-0.4-1-1-1s-1,0.4-1,1v6H2V2h12v7c0,0.6,0.4,1,1,1s1-0.4,1-1V2
            c0-1.1-0.9-2-2-2L2,0C0.9,0,0,0.9,0,2z"
        />
        <path
            d="M19.3,18.7c-0.4,0.4-0.4,1,0,1.4c0.4,0.4,1,0.4,1.4,0l5.4-5.4l0,0c0.1-0.1,0.2-0.2,0.2-0.3c0.2-0.4,0.1-0.8-0.2-1.1
            l-5.5-5.5c-0.4-0.4-1-0.4-1.4,0c-0.4,0.4-0.4,1,0,1.4L23,13H6.5c-0.6,0-1,0.4-1,1s0.4,1,1,1H23L19.3,18.7z"
        />
    </svg>
);

export const GoogleIcon = () => (
    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 100 100">
        <path
            d="M97.73,40.91H51.14v19.32h26.82C75.45,72.5,65,79.55,51.14,79.55c-16.36,0-29.55-13.18-29.55-29.55
        s13.18-29.55,29.55-29.55c7.05,0,13.41,2.5,18.41,6.59L84.09,12.5C75.23,4.77,63.86,0,51.14,0c-27.73,0-50,22.27-50,50
        c0,27.73,22.27,50,50,50c25,0,47.73-18.18,47.73-50C98.86,47.05,98.41,43.86,97.73,40.91z"
        />
    </svg>
);

export const AppleIcon = () => (
    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 100 100">
        <g>
            <path
                d="M78.18,53.13c0.15,15.13,13.71,20.17,13.86,20.23c-0.11,0.36-2.17,7.18-7.14,14.22
            c-4.3,6.09-8.77,12.16-15.8,12.29c-6.91,0.12-9.14-3.97-17.04-3.97c-7.9,0-10.37,3.84-16.91,4.09c-6.79,0.25-11.96-6.59-16.3-12.66
            C9.96,74.92,3.19,52.25,12.29,36.95c4.52-7.6,12.6-12.41,21.36-12.53c6.67-0.12,12.96,4.35,17.04,4.35
            c4.07,0,11.72-5.37,19.76-4.58c3.37,0.14,12.81,1.32,18.88,9.92C88.84,34.39,78.06,40.47,78.18,53.13 M65.18,15.97
            C68.79,11.74,71.22,5.85,70.55,0c-5.2,0.2-11.48,3.35-15.21,7.58c-3.34,3.74-6.27,9.73-5.48,15.47
            C55.66,23.48,61.58,20.2,65.18,15.97"
            />
        </g>
    </svg>
);

export const ArrowLeftLine = () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20.96 12.91">
        <path
            d="M3.42,15H20a1,1,0,0,0,0-2H3.42L7.2,9.21A1,1,0,0,0,5.79,7.8L.3,13.29a1,1,0,0,0-.22,1.09,1,1,0,0,0,.21.32h0l5.43,5.43a1,1,0,0,0,1.41-1.41Z"
            transform="translate(0 -7.51)"
        />
    </svg>
);

export const ArrowRightLine = () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20.96 12.91">
        <path
            d="M13.83,18.72a1,1,0,0,0,0,1.41,1,1,0,0,0,1.41,0l5.43-5.43h0a.85.85,0,0,0,.21-.32,1,1,0,0,0-.22-1.09L15.17,7.8a1,1,0,0,0-1.41,0,1,1,0,0,0,0,1.41L17.54,13H1a1,1,0,0,0,0,2H17.54Z"
            transform="translate(0 -7.51)"
        />
    </svg>
);

export const Users = () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor">
        <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
        <circle cx="9" cy="7" r="4" />
        <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
        <path d="M16 3.13a4 4 0 0 1 0 7.75" />
    </svg>
);

export const Maintenance = () => (
    <Tooltip placement="right" title={<FormattedMessage id="sideMenu.hoverMessages.Entretien" />}>
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="15pt"
            height="15pt"
            viewBox="0 0 15 15"
            version="1.1"
        >
            <g id="surface1">
                <path d="M 10.835938 8.214844 L 9.835938 9.214844 L 2.925781 2.304688 L 3.457031 1.773438 L 1.257812 0 L 0 1.257812 L 1.773438 3.457031 L 2.304688 2.925781 L 9.214844 9.835938 L 8.214844 10.835938 L 9.640625 12.261719 L 12.261719 9.640625 Z M 10.835938 8.214844 " />
                <path d="M 12.882812 10.261719 L 10.261719 12.882812 L 11.835938 14.457031 C 12.183594 14.808594 12.652344 15 13.144531 15 C 13.640625 15 14.105469 14.808594 14.457031 14.457031 C 15.179688 13.734375 15.179688 12.558594 14.457031 11.835938 Z M 12.882812 10.261719 " />
                <path d="M 7.589844 9.457031 L 5.542969 7.410156 L 4.042969 8.90625 C 2.945312 8.5625 1.742188 8.851562 0.914062 9.679688 C 0.324219 10.269531 0 11.050781 0 11.882812 C 0 12.714844 0.324219 13.5 0.914062 14.085938 C 1.519531 14.695312 2.320312 15 3.117188 15 C 3.914062 15 4.710938 14.695312 5.320312 14.085938 C 6.148438 13.257812 6.4375 12.058594 6.09375 10.957031 Z M 3.828125 12.597656 C 3.4375 12.992188 2.796875 12.992188 2.402344 12.597656 C 2.007812 12.203125 2.007812 11.5625 2.402344 11.171875 C 2.796875 10.777344 3.4375 10.777344 3.828125 11.171875 C 4.222656 11.5625 4.222656 12.203125 3.828125 12.597656 Z M 3.828125 12.597656 " />
                <path d="M 14.796875 1.878906 L 14.550781 1.253906 L 12.976562 2.828125 L 12.34375 2.65625 L 12.171875 2.023438 L 13.746094 0.449219 L 13.121094 0.203125 C 12.023438 -0.226562 10.777344 0.0351562 9.945312 0.867188 C 9.183594 1.628906 8.902344 2.738281 9.1875 3.761719 L 7.40625 5.542969 L 9.457031 7.59375 L 11.238281 5.8125 C 11.5 5.886719 11.769531 5.921875 12.039062 5.921875 C 12.808594 5.921875 13.566406 5.621094 14.132812 5.054688 C 14.964844 4.222656 15.226562 2.976562 14.796875 1.878906 Z M 14.796875 1.878906 " />
            </g>
        </svg>
    </Tooltip>
);

export const NSIM = () => (
    <Tooltip placement="right" title={<FormattedMessage id="sideMenu.hoverMessages.Itineraire" />}>
        <svg
            aria-hidden="true"
            focusable="false"
            data-prefix="fas"
            data-icon="route"
            className="svg-inline--fa fa-route fa-w-16"
            role="img"
            xmlns="http://www.w3.org/2000/svg"
            width="15pt"
            height="15pt"
            viewBox="0 0 512 512"
        >
            <path
                fill="white"
                d="M416 320h-96c-17.6 0-32-14.4-32-32s14.4-32 32-32h96s96-107 96-160-43-96-96-96-96 43-96 96c0 25.5 22.2 63.4 45.3 96H320c-52.9 0-96 43.1-96 96s43.1 96 96 96h96c17.6 0 32 14.4 32 32s-14.4 32-32 32H185.5c-16 24.8-33.8 47.7-47.3 64H416c52.9 0 96-43.1 96-96s-43.1-96-96-96zm0-256c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zM96 256c-53 0-96 43-96 96s96 160 96 160 96-107 96-160-43-96-96-96zm0 128c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"
            />
        </svg>
    </Tooltip>
);

export const Apollo = () => (
    <Tooltip placement="right" title={<FormattedMessage id="sideMenu.hoverMessages.DCE" />}>
        <svg
            id="Calque_1"
            data-name="Calque 1"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 19.2 20.67"
            width="19pt"
        >
            <rect fill="#fff" x="17" y="5.83" width="2.1" height="9.11" rx=".37" ry=".37" />
            <path
                fill="#fff"
                d="M17.6,3.31h.9c.33,0,.6,.27,.6,.6v.96c0,.14-.11,.25-.25,.25h-1.6c-.14,0-.25-.11-.25-.25v-.96c0-.33,.27-.6,.6-.6Z"
            />
            <path
                fill="#fff"
                d="M17.11,15.85c.56,.91,.82,1.36,.94,1.58,.04,.08,.16,.07,.2,0l.77-1.59c.04-.08-.02-.16-.1-.16h-1.71c-.09,0-.14,.1-.09,.18Z"
            />
            <path
                fill="#fff"
                d="M10.88,5.42H4.49c-.14,0-.25,.11-.25,.25v5.11c0,.14,.11,.25,.25,.25h6.39c.14,0,.25-.11,.25-.25V5.67c0-.14-.11-.25-.25-.25Zm-.01,5.15c0,.14-.11,.25-.25,.25H4.76c-.14,0-.25-.11-.25-.25V5.88c0-.14,.11-.25,.25-.25h5.86c.14,0,.25,.11,.25,.25v4.69Z"
            />
            <path
                fill="#fff"
                d="M14.74,1.39H1c-.55,0-1,.45-1,1V19.67c0,.55,.45,1,1,1H14.74c.55,0,1-.45,1-1V2.39c0-.55-.45-1-1-1Zm.3,17.65c0,.53-.42,.96-.94,.96H1.64c-.52,0-.94-.43-.94-.96V3.02c0-.53,.42-.96,.94-.96H14.1c.52,0,.94,.43,.94,.96V19.05Z"
            />
            <rect fill="#fff" x="4.23" y="12.58" width="6.89" height=".66" rx=".32" ry=".32" />
            <rect fill="#fff" x="4.23" y="14.58" width="6.89" height=".66" rx=".32" ry=".32" />
            <rect fill="#fff" x="4.23" y="16.58" width="6.89" height=".66" rx=".32" ry=".32" />
            <rect fill="#fff" x="8.2" y="0" width=".43" height="2.79" rx=".22" ry=".22" />
            <rect fill="#fff" x="6.2" y="0" width=".43" height="2.79" rx=".22" ry=".22" />
            <rect fill="#fff" x="4.2" y="0" width=".43" height="2.79" rx=".22" ry=".22" />
            <rect fill="#fff" x="2.2" y="0" width=".43" height="2.79" rx=".22" ry=".22" />
            <rect fill="#fff" x="10.2" y="0" width=".43" height="2.79" rx=".22" ry=".22" />
            <rect fill="#fff" x="12.2" y="0" width=".43" height="2.79" rx=".22" ry=".22" />
        </svg>
    </Tooltip>
);
export const AutoPartage = () => (
    <Tooltip placement="right" title={<FormattedMessage id="sideMenu.hoverMessages.AutoPartage" />}>
        <svg
            id="Layer_1"
            data-name="Layer 1"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 13.85 15.41"
            width="36px"
        >
            <g id="Page-1">
                <path
                    id="Shape"
                    className="cls-1"
                    d="M36.14,30c-.2,0-.47-.37-.63-.83l-.35-1.08a1.27,1.27,0,0,0-1.11-.83H30.62a1.28,1.28,0,0,0-1.11.83l-.35,1.08c-.16.45-.43.83-.63.83s-.35.4-.35.87v1.3a.89.89,0,0,0,.55.83v.81a.35.35,0,0,0,.34.35h.7a.36.36,0,0,0,.36-.35v-.75H34.5v.75a.36.36,0,0,0,.36.35h.7a.34.34,0,0,0,.34-.35V33a.89.89,0,0,0,.55-.83V30.9C36.5,30.4,36.34,30,36.14,30Zm-.32,1.64a.62.62,0,0,1-.61.63.62.62,0,0,1-.61-.63.62.62,0,0,1,.61-.63A.61.61,0,0,1,35.82,31.67Zm-5.74,0a.62.62,0,0,1-.61.63.62.62,0,0,1-.61-.63.62.62,0,0,1,.61-.63A.6.6,0,0,1,30.08,31.67Zm.1-2.27c0-.42.34-1.27.73-1.27h2.94c.42,0,.73.85.73,1.27a.74.74,0,0,1-.73.75H30.91A.71.71,0,0,1,30.18,29.4Z"
                    transform="translate(-25.07 -22.42)"
                />
            </g>
            <path
                className="cls-2"
                d="M34.12,24.32a7,7,0,0,1,4,3.44,6.64,6.64,0,0,1,.36,5.09A6.38,6.38,0,0,0,37.7,28a6.17,6.17,0,0,0-3.85-2.72Z"
                transform="translate(-25.07 -22.42)"
            />
            <path
                d="M34.12,24.32a7,7,0,0,1,4,3.44,6.64,6.64,0,0,1,.36,5.09A6.38,6.38,0,0,0,37.7,28a6.17,6.17,0,0,0-3.85-2.72Z"
                transform="translate(-25.07 -22.42)"
            />
            <path
                d="M36.78,36.4a6.8,6.8,0,0,1-4.44,1.42,6.56,6.56,0,0,1-4.16-1.68,6.35,6.35,0,0,0,4.16,1.18,6,6,0,0,0,3.8-1.68Z"
                transform="translate(-25.07 -22.42)"
            />
            <path
                d="M25.19,32.7a7,7,0,0,1,1.09-5.18,6.69,6.69,0,0,1,4.3-2.77,6.43,6.43,0,0,0-3.87,3,6.18,6.18,0,0,0-.55,4.69Z"
                transform="translate(-25.07 -22.42)"
            />
            <path
                d="M32.56,23.7a.69.69,0,0,0,.31-.58.7.7,0,1,0-1.39,0,.69.69,0,0,0,.31.58,1.13,1.13,0,0,0-.73,1.05v.09h2.23v-.09A1.12,1.12,0,0,0,32.56,23.7Zm-.89-.58a.51.51,0,0,1,.51-.51.51.51,0,1,1,0,1A.51.51,0,0,1,31.67,23.12Zm-.42,1.54a.94.94,0,0,1,.93-.84.93.93,0,0,1,.92.84Z"
                transform="translate(-25.07 -22.42)"
            />
            <path
                d="M38.19,34.51a.71.71,0,0,0,.32-.59.7.7,0,0,0-1.4,0,.71.71,0,0,0,.32.59,1.1,1.1,0,0,0-.74,1v.09h2.24v-.09A1.1,1.1,0,0,0,38.19,34.51Zm-.89-.59a.51.51,0,1,1,.51.52A.51.51,0,0,1,37.3,33.92Zm-.42,1.54a.94.94,0,0,1,.93-.84.92.92,0,0,1,.92.84Z"
                transform="translate(-25.07 -22.42)"
            />
            <path
                d="M26.94,34.51a.7.7,0,0,0,.31-.59.7.7,0,0,0-1.39,0,.7.7,0,0,0,.31.59,1.11,1.11,0,0,0-.73,1v.09h2.23v-.09A1.1,1.1,0,0,0,26.94,34.51Zm-.9-.59a.52.52,0,1,1,.52.52A.51.51,0,0,1,26,33.92Zm-.41,1.54a.93.93,0,0,1,1.85,0Z"
                transform="translate(-25.07 -22.42)"
            />
        </svg>
    </Tooltip>
);

export const ApDelete = () => (
    <svg
        id="Layer_1"
        data-name="Layer 1"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 16.67 18.33"
        width="16px"
    >
        <path
            fill="none"
            stroke="#6f6f6f"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.67px"
            d="M826.28,569.61H828m0,0h13.33m-13.33,0v11.67a1.67,1.67,0,0,0,1.67,1.66H838a1.64,1.64,0,0,0,1.18-.49,1.66,1.66,0,0,0,.49-1.17V569.61Zm2.5,0v-1.67a1.66,1.66,0,0,1,1.67-1.66h3.33a1.67,1.67,0,0,1,1.18.48,1.7,1.7,0,0,1,.49,1.18v1.67m-5,4.17v5m3.33-5v5"
            transform="translate(-825.45 -565.44)"
        />
    </svg>
);
export const ApEdit = (props) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        viewBox="0 0 18.19 18.19"
        width="16px"
    >
        <defs>
            <style
            >{`.cls-1,.cls-3{fill:none;}.cls-2{clip-path:url(#clip-path);}.cls-3{stroke:#6f6f6f;strokeLinecap:round;strokeLinejoin:round;strokeWidth:1.67px;}`}</style>
            <clipPath id="clip-path" transform="translate(-824.62 -565.59)">
                <rect className="cls-1" x="823.78" y="564.61" width="20" height="20" />
            </clipPath>
        </defs>
        <title>{props.title}</title>
        <g className="cls-2">
            <path
                className="cls-3"
                d="M838,567.11a2.42,2.42,0,0,1,.76-.51,2.38,2.38,0,0,1,.91-.18,2.33,2.33,0,0,1,.9.18,2.42,2.42,0,0,1,.76.51,2.26,2.26,0,0,1,.51.76,2.37,2.37,0,0,1,0,1.81,2.26,2.26,0,0,1-.51.76L830,581.69l-4.58,1.25,1.25-4.58Z"
                transform="translate(-824.62 -565.59)"
            />
        </g>
        <path
            className="cls-2"
            d="M34.12,24.32a7,7,0,0,1,4,3.44,6.64,6.64,0,0,1,.36,5.09A6.38,6.38,0,0,0,37.7,28a6.17,6.17,0,0,0-3.85-2.72Z"
            transform="translate(-25.07 -22.42)"
        />
        <path
            className="cls-2"
            d="M36.78,36.4a6.8,6.8,0,0,1-4.44,1.42,6.56,6.56,0,0,1-4.16-1.68,6.35,6.35,0,0,0,4.16,1.18,6,6,0,0,0,3.8-1.68Z"
            transform="translate(-25.07 -22.42)"
        />
        <path
            className="cls-2"
            d="M25.19,32.7a7,7,0,0,1,1.09-5.18,6.69,6.69,0,0,1,4.3-2.77,6.43,6.43,0,0,0-3.87,3,6.18,6.18,0,0,0-.55,4.69Z"
            transform="translate(-25.07 -22.42)"
        />
        <path
            className="cls-2"
            d="M32.56,23.7a.69.69,0,0,0,.31-.58.7.7,0,1,0-1.39,0,.69.69,0,0,0,.31.58,1.13,1.13,0,0,0-.73,1.05v.09h2.23v-.09A1.12,1.12,0,0,0,32.56,23.7Zm-.89-.58a.51.51,0,0,1,.51-.51.51.51,0,1,1,0,1A.51.51,0,0,1,31.67,23.12Zm-.42,1.54a.94.94,0,0,1,.93-.84.93.93,0,0,1,.92.84Z"
            transform="translate(-25.07 -22.42)"
        />
        <path
            className="cls-2"
            d="M38.19,34.51a.71.71,0,0,0,.32-.59.7.7,0,0,0-1.4,0,.71.71,0,0,0,.32.59,1.1,1.1,0,0,0-.74,1v.09h2.24v-.09A1.1,1.1,0,0,0,38.19,34.51Zm-.89-.59a.51.51,0,1,1,.51.52A.51.51,0,0,1,37.3,33.92Zm-.42,1.54a.94.94,0,0,1,.93-.84.92.92,0,0,1,.92.84Z"
            transform="translate(-25.07 -22.42)"
        />
        <path
            className="cls-2"
            d="M26.94,34.51a.7.7,0,0,0,.31-.59.7.7,0,0,0-1.39,0,.7.7,0,0,0,.31.59,1.11,1.11,0,0,0-.73,1v.09h2.23v-.09A1.1,1.1,0,0,0,26.94,34.51Zm-.9-.59a.52.52,0,1,1,.52.52A.51.51,0,0,1,26,33.92Zm-.41,1.54a.93.93,0,0,1,1.85,0Z"
            transform="translate(-25.07 -22.42)"
        />
    </svg>
);

export const Apalert = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M16.0001 2.99995L21.0001 7.99995L21.0001 15.9999L16.0001 20.9999L8.00006 20.9999L3.00006 15.9999L3.00006 7.99995L8.00006 2.99995L16.0001 2.99995Z"
            stroke="white"
            strokeLinejoin="round"
        />
        <path d="M12 8V13" stroke="white" strokeLinecap="round" />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12 17C12.5523 17 13 16.5523 13 16C13 15.4477 12.5523 15 12 15C11.4477 15 11 15.4477 11 16C11 16.5523 11.4477 17 12 17Z"
            fill="white"
        />
    </svg>
);
export const ApHomeIcon = () => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M2 14.7879V6.78792L8 1.33337L14 6.78792V14.7879H2Z" stroke="#6E6E6E" />
        <rect x="6" y="9.33337" width="4" height="5.33333" rx="1" stroke="#6E6E6E" />
    </svg>
);
export const ApVector = () => (
    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M4 8.4V3.6C4 3.35279 4.28223 3.21167 4.48 3.36L7.68 5.76C7.84 5.88 7.84 6.12 7.68 6.24L4.48 8.64C4.28223 8.78833 4 8.64721 4 8.4Z"
            fill="#D8DAE5"
        />
    </svg>
);
export const ApReservationIcon = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M17 12H7" stroke="white" strokeLinecap="round" />
        <path d="M12 17V7" stroke="white" strokeLinecap="round" />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
            stroke="white"
        />
    </svg>
);
export const ApReservationStepIcon = (index, activeStep) => {
    const isActiveStep = index === activeStep;
    const isPassedStep = index < activeStep;
    const iconColor = isActiveStep ? '#4F9C20' : isPassedStep ? '#6F6F6F' : 'white';
    const numberColor = isActiveStep ? 'white' : isPassedStep ? 'white' : '#6F6F6F';
    return (
        <svg
            width="29"
            height="31"
            viewBox="0 0 29 31"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            stroke={isPassedStep ? '#6F6F6F' : '#4F9C20'}
            strokeWidth="1.2"
        >
            <rect y="0.5" width="29" height="30" rx="8" fill={iconColor} />
            <foreignObject x="0" y="0" width="100%" height="100%">
                <div
                    xmlns="http://www.w3.org/1999/xhtml"
                    style={{
                        color: numberColor,
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        width: '100%',
                        height: '100%',
                    }}
                >
                    {index + 1}
                </div>
            </foreignObject>
        </svg>
    );
};

export const ApSidebarReservationIcon = () => (
    <svg width="23" height="23" viewBox="0 0 26 23" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M7.7238 0.939821C8.22654 1.39177 8.26716 2.15857 7.81521 2.66131L4.15896 6.72381C3.93552 6.97263 3.62068 7.1199 3.28552 7.12498C2.95037 7.13005 2.63044 7.0031 2.39177 6.76951L0.355444 4.73826C-0.116821 4.26091 -0.116821 3.48904 0.355444 3.0117C0.82771 2.53435 1.60466 2.53435 2.07693 3.0117L3.19919 4.13396L5.99724 1.02615C6.44919 0.523415 7.21599 0.48279 7.71873 0.934743L7.7238 0.939821ZM7.7238 9.06482C8.22654 9.51677 8.26716 10.2836 7.81521 10.7863L4.15896 14.8488C3.93552 15.0976 3.62068 15.2449 3.28552 15.25C2.95037 15.2551 2.63044 15.1281 2.39177 14.8945L0.355444 12.8633C-0.121899 12.3859 -0.121899 11.614 0.355444 11.1418C0.832788 10.6695 1.60466 10.6644 2.07693 11.1418L3.19919 12.264L5.99724 9.15623C6.44919 8.65349 7.21599 8.61287 7.71873 9.06482H7.7238ZM11.375 3.87498C11.375 2.97615 12.1011 2.24998 13 2.24998H24.375C25.2738 2.24998 26 2.97615 26 3.87498C26 4.77381 25.2738 5.49998 24.375 5.49998H13C12.1011 5.49998 11.375 4.77381 11.375 3.87498ZM11.375 12C11.375 11.1011 12.1011 10.375 13 10.375H24.375C25.2738 10.375 26 11.1011 26 12C26 12.8988 25.2738 13.625 24.375 13.625H13C12.1011 13.625 11.375 12.8988 11.375 12ZM8.12498 20.125C8.12498 19.2261 8.85115 18.5 9.74998 18.5H24.375C25.2738 18.5 26 19.2261 26 20.125C26 21.0238 25.2738 21.75 24.375 21.75H9.74998C8.85115 21.75 8.12498 21.0238 8.12498 20.125ZM2.43748 17.6875C3.08394 17.6875 3.70393 17.9443 4.16105 18.4014C4.61817 18.8585 4.87498 19.4785 4.87498 20.125C4.87498 20.7714 4.61817 21.3914 4.16105 21.8486C3.70393 22.3057 3.08394 22.5625 2.43748 22.5625C1.79101 22.5625 1.17102 22.3057 0.713903 21.8486C0.256783 21.3914 -2.44286e-05 20.7714 -2.44286e-05 20.125C-2.44286e-05 19.4785 0.256783 18.8585 0.713903 18.4014C1.17102 17.9443 1.79101 17.6875 2.43748 17.6875Z"
            fill="white"
        />
    </svg>
);

export const ApCheckMarkIcon = () => (
    <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M18.0203 5.25877C18.3376 5.59212 18.3246 6.1196 17.9912 6.43692L8.36162 15.6036C8.19717 15.7601 7.97597 15.8428 7.74916 15.8325C7.52236 15.8222 7.30958 15.7197 7.16003 15.5489L3.45633 11.3181C3.15318 10.9718 3.18815 10.4454 3.53444 10.1422C3.88073 9.83907 4.40721 9.87404 4.71036 10.2203L7.84178 13.7974L16.8421 5.22975C17.1755 4.91242 17.7029 4.92542 18.0203 5.25877Z"
            fill="white"
        />
    </svg>
);
export const ApCheckIcon = () => (
    <svg width="16" height="11" viewBox="0 0 16 11" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M14.6666 1L5.49992 10.1667L1.33325 6"
            stroke="#0B802C"
            strokeWidth="1.66667"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

export const ApCloseIcon = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M17.6569 17.6568L6.34319 6.34309" stroke="#6F6F6F" strokeLinecap="round" />
        <path d="M17.6568 6.34309L6.34311 17.6568" stroke="#6F6F6F" strokeLinecap="round" />
    </svg>
);
export const ApArrowRightIcon = () => (
    <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M6.5 4L10.5 8L6.5 12"
            stroke="#4F9C20"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);
export const ApArrowLeftIcon = () => (
    <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M10.5 12L6.5 8L10.5 4"
            stroke="#4F9C20"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);
export const ApSectorIcon = () => (
    <svg width="15" height="14" viewBox="0 0 15 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M1.9165 2.91667L5.4165 1.75V11.0833L1.9165 12.25V2.91667Z"
            stroke="white"
            strokeLinejoin="round"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8.9165 2.91667L12.4165 1.75V11.0833L8.9165 12.25V2.91667Z"
            stroke="white"
            strokeLinejoin="round"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8.9165 2.91667L5.4165 1.75V11.0833L8.9165 12.25V2.91667Z"
            stroke="white"
            strokeLinejoin="round"
        />
    </svg>
);

export const ApStepperSeperator = () => (
    <svg width="83" height="45" viewBox="0 0 83 45" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M1.97869 25.0945C1.70691 25.0945 1.47325 24.9983 1.2777 24.8061C1.08215 24.6106 0.984375 24.3752 0.984375 24.1001C0.984375 23.8284 1.08215 23.5964 1.2777 23.4041C1.47325 23.2086 1.70691 23.1108 1.97869 23.1108C2.25047 23.1108 2.48414 23.2086 2.67969 23.4041C2.87524 23.5964 2.97301 23.8284 2.97301 24.1001C2.97301 24.2824 2.92661 24.4498 2.83381 24.6023C2.74432 24.7514 2.625 24.8707 2.47585 24.9602C2.3267 25.0497 2.16098 25.0945 1.97869 25.0945ZM5.94354 25.0945C5.67176 25.0945 5.43809 24.9983 5.24254 24.8061C5.04699 24.6106 4.94922 24.3752 4.94922 24.1001C4.94922 23.8284 5.04699 23.5964 5.24254 23.4041C5.43809 23.2086 5.67176 23.1108 5.94354 23.1108C6.21532 23.1108 6.44898 23.2086 6.64453 23.4041C6.84008 23.5964 6.93786 23.8284 6.93786 24.1001C6.93786 24.2824 6.89145 24.4498 6.79865 24.6023C6.70916 24.7514 6.58984 24.8707 6.4407 24.9602C6.29155 25.0497 6.12583 25.0945 5.94354 25.0945ZM9.90838 25.0945C9.6366 25.0945 9.40294 24.9983 9.20739 24.8061C9.01184 24.6106 8.91406 24.3752 8.91406 24.1001C8.91406 23.8284 9.01184 23.5964 9.20739 23.4041C9.40294 23.2086 9.6366 23.1108 9.90838 23.1108C10.1802 23.1108 10.4138 23.2086 10.6094 23.4041C10.8049 23.5964 10.9027 23.8284 10.9027 24.1001C10.9027 24.2824 10.8563 24.4498 10.7635 24.6023C10.674 24.7514 10.5547 24.8707 10.4055 24.9602C10.2564 25.0497 10.0907 25.0945 9.90838 25.0945Z"
            fill="#667085"
        />
        <path
            d="M13.9787 25.0945C13.7069 25.0945 13.4732 24.9983 13.2777 24.8061C13.0821 24.6106 12.9844 24.3752 12.9844 24.1001C12.9844 23.8284 13.0821 23.5964 13.2777 23.4041C13.4732 23.2086 13.7069 23.1108 13.9787 23.1108C14.2505 23.1108 14.4841 23.2086 14.6797 23.4041C14.8752 23.5964 14.973 23.8284 14.973 24.1001C14.973 24.2824 14.9266 24.4498 14.8338 24.6023C14.7443 24.7514 14.625 24.8707 14.4759 24.9602C14.3267 25.0497 14.161 25.0945 13.9787 25.0945ZM17.9435 25.0945C17.6718 25.0945 17.4381 24.9983 17.2425 24.8061C17.047 24.6106 16.9492 24.3752 16.9492 24.1001C16.9492 23.8284 17.047 23.5964 17.2425 23.4041C17.4381 23.2086 17.6718 23.1108 17.9435 23.1108C18.2153 23.1108 18.449 23.2086 18.6445 23.4041C18.8401 23.5964 18.9379 23.8284 18.9379 24.1001C18.9379 24.2824 18.8915 24.4498 18.7987 24.6023C18.7092 24.7514 18.5898 24.8707 18.4407 24.9602C18.2915 25.0497 18.1258 25.0945 17.9435 25.0945ZM21.9084 25.0945C21.6366 25.0945 21.4029 24.9983 21.2074 24.8061C21.0118 24.6106 20.9141 24.3752 20.9141 24.1001C20.9141 23.8284 21.0118 23.5964 21.2074 23.4041C21.4029 23.2086 21.6366 23.1108 21.9084 23.1108C22.1802 23.1108 22.4138 23.2086 22.6094 23.4041C22.8049 23.5964 22.9027 23.8284 22.9027 24.1001C22.9027 24.2824 22.8563 24.4498 22.7635 24.6023C22.674 24.7514 22.5547 24.8707 22.4055 24.9602C22.2564 25.0497 22.0907 25.0945 21.9084 25.0945Z"
            fill="#667085"
        />
        <path
            d="M25.9787 25.0945C25.7069 25.0945 25.4732 24.9983 25.2777 24.8061C25.0821 24.6106 24.9844 24.3752 24.9844 24.1001C24.9844 23.8284 25.0821 23.5964 25.2777 23.4041C25.4732 23.2086 25.7069 23.1108 25.9787 23.1108C26.2505 23.1108 26.4841 23.2086 26.6797 23.4041C26.8752 23.5964 26.973 23.8284 26.973 24.1001C26.973 24.2824 26.9266 24.4498 26.8338 24.6023C26.7443 24.7514 26.625 24.8707 26.4759 24.9602C26.3267 25.0497 26.161 25.0945 25.9787 25.0945ZM29.9435 25.0945C29.6718 25.0945 29.4381 24.9983 29.2425 24.8061C29.047 24.6106 28.9492 24.3752 28.9492 24.1001C28.9492 23.8284 29.047 23.5964 29.2425 23.4041C29.4381 23.2086 29.6718 23.1108 29.9435 23.1108C30.2153 23.1108 30.449 23.2086 30.6445 23.4041C30.8401 23.5964 30.9379 23.8284 30.9379 24.1001C30.9379 24.2824 30.8915 24.4498 30.7987 24.6023C30.7092 24.7514 30.5898 24.8707 30.4407 24.9602C30.2915 25.0497 30.1258 25.0945 29.9435 25.0945ZM33.9084 25.0945C33.6366 25.0945 33.4029 24.9983 33.2074 24.8061C33.0118 24.6106 32.9141 24.3752 32.9141 24.1001C32.9141 23.8284 33.0118 23.5964 33.2074 23.4041C33.4029 23.2086 33.6366 23.1108 33.9084 23.1108C34.1802 23.1108 34.4138 23.2086 34.6094 23.4041C34.8049 23.5964 34.9027 23.8284 34.9027 24.1001C34.9027 24.2824 34.8563 24.4498 34.7635 24.6023C34.674 24.7514 34.5547 24.8707 34.4055 24.9602C34.2564 25.0497 34.0907 25.0945 33.9084 25.0945Z"
            fill="#667085"
        />
        <path
            d="M37.9787 25.0945C37.7069 25.0945 37.4732 24.9983 37.2777 24.8061C37.0821 24.6106 36.9844 24.3752 36.9844 24.1001C36.9844 23.8284 37.0821 23.5964 37.2777 23.4041C37.4732 23.2086 37.7069 23.1108 37.9787 23.1108C38.2505 23.1108 38.4841 23.2086 38.6797 23.4041C38.8752 23.5964 38.973 23.8284 38.973 24.1001C38.973 24.2824 38.9266 24.4498 38.8338 24.6023C38.7443 24.7514 38.625 24.8707 38.4759 24.9602C38.3267 25.0497 38.161 25.0945 37.9787 25.0945ZM41.9435 25.0945C41.6718 25.0945 41.4381 24.9983 41.2425 24.8061C41.047 24.6106 40.9492 24.3752 40.9492 24.1001C40.9492 23.8284 41.047 23.5964 41.2425 23.4041C41.4381 23.2086 41.6718 23.1108 41.9435 23.1108C42.2153 23.1108 42.449 23.2086 42.6445 23.4041C42.8401 23.5964 42.9379 23.8284 42.9379 24.1001C42.9379 24.2824 42.8915 24.4498 42.7987 24.6023C42.7092 24.7514 42.5898 24.8707 42.4407 24.9602C42.2915 25.0497 42.1258 25.0945 41.9435 25.0945ZM45.9084 25.0945C45.6366 25.0945 45.4029 24.9983 45.2074 24.8061C45.0118 24.6106 44.9141 24.3752 44.9141 24.1001C44.9141 23.8284 45.0118 23.5964 45.2074 23.4041C45.4029 23.2086 45.6366 23.1108 45.9084 23.1108C46.1802 23.1108 46.4138 23.2086 46.6094 23.4041C46.8049 23.5964 46.9027 23.8284 46.9027 24.1001C46.9027 24.2824 46.8563 24.4498 46.7635 24.6023C46.674 24.7514 46.5547 24.8707 46.4055 24.9602C46.2564 25.0497 46.0907 25.0945 45.9084 25.0945Z"
            fill="#667085"
        />
        <path
            d="M49.9787 25.0945C49.7069 25.0945 49.4732 24.9983 49.2777 24.8061C49.0821 24.6106 48.9844 24.3752 48.9844 24.1001C48.9844 23.8284 49.0821 23.5964 49.2777 23.4041C49.4732 23.2086 49.7069 23.1108 49.9787 23.1108C50.2505 23.1108 50.4841 23.2086 50.6797 23.4041C50.8752 23.5964 50.973 23.8284 50.973 24.1001C50.973 24.2824 50.9266 24.4498 50.8338 24.6023C50.7443 24.7514 50.625 24.8707 50.4759 24.9602C50.3267 25.0497 50.161 25.0945 49.9787 25.0945ZM53.9435 25.0945C53.6718 25.0945 53.4381 24.9983 53.2425 24.8061C53.047 24.6106 52.9492 24.3752 52.9492 24.1001C52.9492 23.8284 53.047 23.5964 53.2425 23.4041C53.4381 23.2086 53.6718 23.1108 53.9435 23.1108C54.2153 23.1108 54.449 23.2086 54.6445 23.4041C54.8401 23.5964 54.9379 23.8284 54.9379 24.1001C54.9379 24.2824 54.8915 24.4498 54.7987 24.6023C54.7092 24.7514 54.5898 24.8707 54.4407 24.9602C54.2915 25.0497 54.1258 25.0945 53.9435 25.0945ZM57.9084 25.0945C57.6366 25.0945 57.4029 24.9983 57.2074 24.8061C57.0118 24.6106 56.9141 24.3752 56.9141 24.1001C56.9141 23.8284 57.0118 23.5964 57.2074 23.4041C57.4029 23.2086 57.6366 23.1108 57.9084 23.1108C58.1802 23.1108 58.4138 23.2086 58.6094 23.4041C58.8049 23.5964 58.9027 23.8284 58.9027 24.1001C58.9027 24.2824 58.8563 24.4498 58.7635 24.6023C58.674 24.7514 58.5547 24.8707 58.4055 24.9602C58.2564 25.0497 58.0907 25.0945 57.9084 25.0945Z"
            fill="#667085"
        />
        <path
            d="M61.9787 25.0945C61.7069 25.0945 61.4732 24.9983 61.2777 24.8061C61.0821 24.6106 60.9844 24.3752 60.9844 24.1001C60.9844 23.8284 61.0821 23.5964 61.2777 23.4041C61.4732 23.2086 61.7069 23.1108 61.9787 23.1108C62.2505 23.1108 62.4841 23.2086 62.6797 23.4041C62.8752 23.5964 62.973 23.8284 62.973 24.1001C62.973 24.2824 62.9266 24.4498 62.8338 24.6023C62.7443 24.7514 62.625 24.8707 62.4759 24.9602C62.3267 25.0497 62.161 25.0945 61.9787 25.0945ZM65.9435 25.0945C65.6718 25.0945 65.4381 24.9983 65.2425 24.8061C65.047 24.6106 64.9492 24.3752 64.9492 24.1001C64.9492 23.8284 65.047 23.5964 65.2425 23.4041C65.4381 23.2086 65.6718 23.1108 65.9435 23.1108C66.2153 23.1108 66.449 23.2086 66.6445 23.4041C66.8401 23.5964 66.9379 23.8284 66.9379 24.1001C66.9379 24.2824 66.8915 24.4498 66.7987 24.6023C66.7092 24.7514 66.5898 24.8707 66.4407 24.9602C66.2915 25.0497 66.1258 25.0945 65.9435 25.0945ZM69.9084 25.0945C69.6366 25.0945 69.4029 24.9983 69.2074 24.8061C69.0118 24.6106 68.9141 24.3752 68.9141 24.1001C68.9141 23.8284 69.0118 23.5964 69.2074 23.4041C69.4029 23.2086 69.6366 23.1108 69.9084 23.1108C70.1802 23.1108 70.4138 23.2086 70.6094 23.4041C70.8049 23.5964 70.9027 23.8284 70.9027 24.1001C70.9027 24.2824 70.8563 24.4498 70.7635 24.6023C70.674 24.7514 70.5547 24.8707 70.4055 24.9602C70.2564 25.0497 70.0907 25.0945 69.9084 25.0945Z"
            fill="#667085"
        />
        <path
            d="M73.9787 25.0945C73.7069 25.0945 73.4732 24.9983 73.2777 24.8061C73.0821 24.6106 72.9844 24.3752 72.9844 24.1001C72.9844 23.8284 73.0821 23.5964 73.2777 23.4041C73.4732 23.2086 73.7069 23.1108 73.9787 23.1108C74.2505 23.1108 74.4841 23.2086 74.6797 23.4041C74.8752 23.5964 74.973 23.8284 74.973 24.1001C74.973 24.2824 74.9266 24.4498 74.8338 24.6023C74.7443 24.7514 74.625 24.8707 74.4759 24.9602C74.3267 25.0497 74.161 25.0945 73.9787 25.0945ZM77.9435 25.0945C77.6718 25.0945 77.4381 24.9983 77.2425 24.8061C77.047 24.6106 76.9492 24.3752 76.9492 24.1001C76.9492 23.8284 77.047 23.5964 77.2425 23.4041C77.4381 23.2086 77.6718 23.1108 77.9435 23.1108C78.2153 23.1108 78.449 23.2086 78.6445 23.4041C78.8401 23.5964 78.9379 23.8284 78.9379 24.1001C78.9379 24.2824 78.8915 24.4498 78.7987 24.6023C78.7092 24.7514 78.5898 24.8707 78.4407 24.9602C78.2915 25.0497 78.1258 25.0945 77.9435 25.0945ZM81.9084 25.0945C81.6366 25.0945 81.4029 24.9983 81.2074 24.8061C81.0118 24.6106 80.9141 24.3752 80.9141 24.1001C80.9141 23.8284 81.0118 23.5964 81.2074 23.4041C81.4029 23.2086 81.6366 23.1108 81.9084 23.1108C82.1802 23.1108 82.4138 23.2086 82.6094 23.4041C82.8049 23.5964 82.9027 23.8284 82.9027 24.1001C82.9027 24.2824 82.8563 24.4498 82.7635 24.6023C82.674 24.7514 82.5547 24.8707 82.4055 24.9602C82.2564 25.0497 82.0907 25.0945 81.9084 25.0945Z"
            fill="#667085"
        />
    </svg>
);
export const ApSearchIcon = () => (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M16.5 16.5L12.875 12.875M14.8333 8.16667C14.8333 11.8486 11.8486 14.8333 8.16667 14.8333C4.48477 14.8333 1.5 11.8486 1.5 8.16667C1.5 4.48477 4.48477 1.5 8.16667 1.5C11.8486 1.5 14.8333 4.48477 14.8333 8.16667Z"
            stroke="#667085"
            strokeWidth="1.66667"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

export const ApVehicleIcon = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M3 12L5 7H7M3 12H2V17H3M3 12H7M18 12L16 7H12M18 12H20C21.1046 12 22 12.8954 22 14V17H20M18 12H12M7 17H16M7 7V12M7 7H12M7 12H12M12 12V7"
            stroke="white"
        />
        <circle cx="5" cy="17" r="2" stroke="white" />
        <circle cx="18" cy="17" r="2" stroke="white" />
    </svg>
);
export const Status_icon_progress = () => (
    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M10 3L4.5 8.5L2 6"
            stroke="#0729A5"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);
export const Status_icon_ended = () => (
    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M10 3L4.5 8.5L2 6"
            stroke="#12B76A"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);
export const Status_icon_canceled = () => (
    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M9 3L3 9M3 3L9 9"
            stroke="#F04438"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);
export const Status_icon_waiting = () => (
    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M4.5 7L2 4.5M2 4.5L4.5 2M2 4.5H8C8.53043 4.5 9.03914 4.71071 9.41421 5.08579C9.78929 5.46086 10 5.96957 10 6.5V10"
            stroke="#667085"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);
export const ApSuccessIcon = () => (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM11 15H9V13H11V15ZM11 11H9V5H11V11Z"
            fill="white"
        />
    </svg>
);
export const ApCloseIconSuccess = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="24" height="24" rx="12" fill="white" fill-opacity="0.35" />
        <path
            d="M16.6663 8.27337L15.7263 7.33337L11.9997 11.06L8.27301 7.33337L7.33301 8.27337L11.0597 12L7.33301 15.7267L8.27301 16.6667L11.9997 12.94L15.7263 16.6667L16.6663 15.7267L12.9397 12L16.6663 8.27337Z"
            fill="white"
        />
    </svg>
);
export const Plus = () => {
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M17 12H7" stroke="black" strokeLinecap="round" />
        <path d="M12 17V7" stroke="black" strokeLinecap="round" />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
            stroke="black"
        />
    </svg>;
};
export const ArrowSvg = () => (
    <svg width="13" height="22" viewBox="0 0 13 22" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M1.46271 20.7188L12.2403 11.0002L1.46271 1.28162"
            stroke="#63AC37"
            stroke-linecap="round"
        />
    </svg>
);
export const StartPositionIcon = () => (
    <svg width="23" height="20" viewBox="0 0 23 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M11.5 17.125C11.5 17.125 17 12.1375 17 7.625C17 5.00165 14.5376 2.875 11.5 2.875C8.46243 2.875 6 5.00165 6 7.625C6 12.1375 11.5 17.125 11.5 17.125Z"
            fill="#63AC37"
            stroke="white"
        />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M11.5 8.41658C12.0063 8.41658 12.4167 8.06214 12.4167 7.62492C12.4167 7.18769 12.0063 6.83325 11.5 6.83325C10.9938 6.83325 10.5834 7.18769 10.5834 7.62492C10.5834 8.06214 10.9938 8.41658 11.5 8.41658Z"
            stroke="white"
        />
    </svg>
);
export const EndPositionIcon = () => (
    <svg width="23" height="20" viewBox="0 0 23 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M11.6106 17.125C11.6106 17.125 17.1106 12.1375 17.1106 7.625C17.1106 5.00165 14.6482 2.875 11.6106 2.875C8.57303 2.875 6.1106 5.00165 6.1106 7.625C6.1106 12.1375 11.6106 17.125 11.6106 17.125Z"
            fill="#FF0000"
            stroke="white"
        />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M11.6106 8.41658C12.1168 8.41658 12.5272 8.06214 12.5272 7.62492C12.5272 7.18769 12.1168 6.83325 11.6106 6.83325C11.1043 6.83325 10.6939 7.18769 10.6939 7.62492C10.6939 8.06214 11.1043 8.41658 11.6106 8.41658Z"
            stroke="white"
        />
    </svg>
);

export const LogoBlackGreen = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        viewBox="0 0 1793.95 260.81"
    >
        <defs>
            <style>{`.cls-1{fill:url(#linear-gradient);}.cls-2{fill:#1d1d1b;}`}</style>
            <linearGradient
                id="linear-gradient"
                x1="255.53"
                y1="168.42"
                x2="634.53"
                y2="168.42"
                gradientUnits="userSpaceOnUse"
            >
                <stop offset="0" stopColor="#008d36" />
                <stop offset="1" stopColor="#6db755" />
            </linearGradient>
        </defs>
        <g id="Layer_2" data-name="Layer 2">
            <g id="Layer_1-2" data-name="Layer 1">
                <path
                    className="cls-1"
                    d="M293.74,93.48c27.28-20.14,65.78-22.89,95.88-7.42,16,7.49,27.21,21.61,40,33.3-30.87,31.31-62.13,62.2-93.14,93.36,15.17,3.17,32.09-.52,43-12,31-31.06,62.15-62,93-93.21C491,86.21,519.67,74.22,547.89,76.26c43.53,1.89,82.5,38.82,86,82.41,5.72,44.72-26.74,89.87-70.6,99.55-41,10.46-87.15-11.64-104.48-50.32,12.89-12.15,24.9-25.21,37.74-37.39.2,24.18,22.79,44.71,46.8,43.21,23.77.08,44.89-21.58,43.93-45.37.86-21.15-15.83-41-36.54-44.57-14.09-2.66-30.08,1.08-39.9,12q-46.08,46.16-92.2,92.21c-24.41,28.41-66.11,40.54-101.57,27.5-28.83-9.95-52-35.16-58.73-65C249,154.89,263.53,114.52,293.74,93.48Zm23.49,40.88a45,45,0,0,0-13.75,44.84C322,160.81,340.32,142.29,359,124.07,344.39,120.73,328.19,123.88,317.23,134.36Z"
                />
                <path
                    className="cls-2"
                    d="M0,135.37C0,68.18,45.75,10.63,118.66,10.63c56.11,0,84.34,24.66,103.28,56.12l-43.6,27.16c-9.65-17.16-29.66-37.17-59.68-37.17C76.48,56.74,54,95,54,135.37s18.94,80.77,69.33,80.77c24.3,0,43.6-8.58,52.18-18.23V163.6H123.66V126.07h97.57v93.28c-21.45,25.74-55.76,41.46-97.57,41.46C44.67,260.81,0,202.2,0,135.37Z"
                />
                <path
                    className="cls-2"
                    d="M697.26,14.21h18.79v65h54.32V120H716.05v60.4c0,22.51,4.65,36.09,24.3,36.09,5.72,0,26.09-1.07,30-2.14v42.89c-8.57,1.78-29.66,3.21-36.09,3.21-46.11-.35-65.76-28.95-65.76-80.41V43A28.75,28.75,0,0,1,697.26,14.21Z"
                />
                <path
                    className="cls-2"
                    d="M803.25,14.21h47.18v84.7C863.65,85,881.52,76,905.83,76c34.3,0,59.68,25.37,59.68,57.9v123.3H916.19V153.59c0-26.44-13.94-32.88-27.16-32.88-14.65,0-27.52,8.22-38.6,21.45V257.24H803.25Z"
                />
                <path
                    className="cls-2"
                    d="M1085.59,76c52.54,0,87.57,34.31,91.5,92.56.35,5.36.35,14.3.35,19.66H1047.35c4.65,16.8,21.45,31.45,42.53,31.45,18.59,0,34.67-10.72,42.18-23.23l37.52,18.58c-16.08,27.17-42.53,45.39-80,45.39-60.4,0-94.36-41.45-94.36-92.56C995.17,117.85,1037,76,1085.59,76Zm40.75,77.2c-1.79-18.59-16.09-36.1-38.6-36.1-23.23,0-37.17,16.44-41.1,36.1Z"
                />
                <path
                    className="cls-2"
                    d="M1207.11,79.25h47.53v20C1267.87,85.33,1285.74,76,1310.4,76c33.59,0,59,25.73,59,58.61V257.24h-49V153.59c0-27.16-14.65-32.52-27.51-32.52-14.3,0-27.17,7.51-38.25,21.44V257.24h-47.53Z"
                />
                <path
                    className="cls-2"
                    d="M1437.79,14.21h18.78v65h54.33V120h-54.33v60.4c0,22.51,4.65,36.09,24.31,36.09,5.71,0,26.09-1.07,30-2.14v42.89c-8.58,1.78-29.67,3.21-36.1,3.21C1428.7,260.1,1409,231.5,1409,180V43A28.75,28.75,0,0,1,1437.79,14.21Z"
                />
                <path
                    className="cls-2"
                    d="M1588.48,8.44h0a28.81,28.81,0,0,1,0,40.74l-1.25,1.25a28.81,28.81,0,0,1-40.74,0h0a28.81,28.81,0,0,1,0-40.74l1.25-1.25A28.81,28.81,0,0,1,1588.48,8.44Zm-16.31,70.81H1591v178h-47.53V108A28.75,28.75,0,0,1,1572.17,79.25Z"
                />
                <path
                    className="cls-2"
                    d="M1621,167.89A92.12,92.12,0,0,1,1713.18,76c38.6,0,67.19,20,80.06,49.68l-37.53,22.51c-6.79-14.65-21.09-29.66-42.17-29.66-29.67,0-43.6,25.73-43.6,49.32,0,23.94,13.93,50,43.6,50,21.44,0,36.45-16.79,43.24-32.16L1794,208.27c-12.51,31.46-41.1,52.18-80.77,52.18A92,92,0,0,1,1621,167.89Z"
                />
            </g>
        </g>
    </svg>
);

export const LogoWhiteGreen = (props) =>
    props.isOpen ? (
        <div className="full-logo">
            <svg
                xmlns="http://www.w3.org/2000/svg"
                xmlnsXlink="http://www.w3.org/1999/xlink"
                viewBox="0 0 1793.95 260.81"
            >
                <defs>
                    <style>{`.cls-1{fill:url(#linear-gradient);}.cls-2{fill:#fff;}`}</style>
                    <linearGradient
                        id="linear-gradient"
                        x1="255.53"
                        y1="168.42"
                        x2="634.53"
                        y2="168.42"
                        gradientUnits="userSpaceOnUse"
                    >
                        <stop offset="0" stopColor="#008d36" />
                        <stop offset="1" stopColor="#6db755" />
                    </linearGradient>
                </defs>

                <g id="Layer_2" data-name="Layer 2">
                    <g id="Layer_1-2" data-name="Layer 1">
                        <path
                            className="cls-1"
                            d="M293.74,93.48c27.28-20.14,65.78-22.89,95.88-7.42,16,7.49,27.21,21.61,40,33.3-30.87,31.31-62.13,62.2-93.14,93.36,15.17,3.17,32.09-.52,43-12,31-31.06,62.15-62,93-93.21C491,86.21,519.67,74.22,547.89,76.26c43.53,1.89,82.5,38.82,86,82.41,5.72,44.72-26.74,89.87-70.6,99.55-41,10.46-87.15-11.64-104.48-50.32,12.89-12.15,24.9-25.21,37.74-37.39.2,24.18,22.79,44.71,46.8,43.21,23.77.08,44.89-21.58,43.93-45.37.86-21.15-15.83-41-36.54-44.57-14.09-2.66-30.08,1.08-39.9,12q-46.08,46.16-92.2,92.21c-24.41,28.41-66.11,40.54-101.57,27.5-28.83-9.95-52-35.16-58.73-65C249,154.89,263.53,114.52,293.74,93.48Zm23.49,40.88a45,45,0,0,0-13.75,44.84C322,160.81,340.32,142.29,359,124.07,344.39,120.73,328.19,123.88,317.23,134.36Z"
                        />
                        <path
                            className="cls-2"
                            d="M0,135.37C0,68.18,45.75,10.63,118.66,10.63c56.11,0,84.34,24.66,103.28,56.12l-43.6,27.16c-9.65-17.16-29.66-37.17-59.68-37.17C76.48,56.74,54,95,54,135.37s18.94,80.77,69.33,80.77c24.3,0,43.6-8.58,52.18-18.23V163.6H123.66V126.07h97.57v93.28c-21.45,25.74-55.76,41.46-97.57,41.46C44.67,260.81,0,202.2,0,135.37Z"
                        />
                        <path
                            className="cls-2"
                            d="M697.26,14.21h18.79v65h54.32V120H716.05v60.4c0,22.51,4.65,36.09,24.3,36.09,5.72,0,26.09-1.07,30-2.14v42.89c-8.57,1.78-29.66,3.21-36.09,3.21-46.11-.35-65.76-28.95-65.76-80.41V43A28.75,28.75,0,0,1,697.26,14.21Z"
                        />
                        <path
                            className="cls-2"
                            d="M803.25,14.21h47.18v84.7C863.65,85,881.52,76,905.83,76c34.3,0,59.68,25.37,59.68,57.9v123.3H916.19V153.59c0-26.44-13.94-32.88-27.16-32.88-14.65,0-27.52,8.22-38.6,21.45V257.24H803.25Z"
                        />
                        <path
                            className="cls-2"
                            d="M1085.59,76c52.54,0,87.57,34.31,91.5,92.56.35,5.36.35,14.3.35,19.66H1047.35c4.65,16.8,21.45,31.45,42.53,31.45,18.59,0,34.67-10.72,42.18-23.23l37.52,18.58c-16.08,27.17-42.53,45.39-80,45.39-60.4,0-94.36-41.45-94.36-92.56C995.17,117.85,1037,76,1085.59,76Zm40.75,77.2c-1.79-18.59-16.09-36.1-38.6-36.1-23.23,0-37.17,16.44-41.1,36.1Z"
                        />
                        <path
                            className="cls-2"
                            d="M1207.11,79.25h47.53v20C1267.87,85.33,1285.74,76,1310.4,76c33.59,0,59,25.73,59,58.61V257.24h-49V153.59c0-27.16-14.65-32.52-27.51-32.52-14.3,0-27.17,7.51-38.25,21.44V257.24h-47.53Z"
                        />
                        <path
                            className="cls-2"
                            d="M1437.79,14.21h18.78v65h54.33V120h-54.33v60.4c0,22.51,4.65,36.09,24.31,36.09,5.71,0,26.09-1.07,30-2.14v42.89c-8.58,1.78-29.67,3.21-36.1,3.21C1428.7,260.1,1409,231.5,1409,180V43A28.75,28.75,0,0,1,1437.79,14.21Z"
                        />
                        <path
                            className="cls-2"
                            d="M1588.48,8.44h0a28.81,28.81,0,0,1,0,40.74l-1.25,1.25a28.81,28.81,0,0,1-40.74,0h0a28.81,28.81,0,0,1,0-40.74l1.25-1.25A28.81,28.81,0,0,1,1588.48,8.44Zm-16.31,70.81H1591v178h-47.53V108A28.75,28.75,0,0,1,1572.17,79.25Z"
                        />
                        <path
                            className="cls-2"
                            d="M1621,167.89A92.12,92.12,0,0,1,1713.18,76c38.6,0,67.19,20,80.06,49.68l-37.53,22.51c-6.79-14.65-21.09-29.66-42.17-29.66-29.67,0-43.6,25.73-43.6,49.32,0,23.94,13.93,50,43.6,50,21.44,0,36.45-16.79,43.24-32.16L1794,208.27c-12.51,31.46-41.1,52.18-80.77,52.18A92,92,0,0,1,1621,167.89Z"
                        />
                    </g>
                </g>
            </svg>
        </div>
    ) : (
        <div className="icon-logo">
            <svg
                xmlns="http://www.w3.org/2000/svg"
                xmlnsXlink="http://www.w3.org/1999/xlink"
                viewBox="0 0 389 184.77"
            >
                <defs>
                    <style>{`.cls-1{fill:url(#linear-gradient);}`}</style>
                    <linearGradient
                        id="linear-gradient"
                        y1="92.39"
                        x2="379"
                        y2="92.39"
                        gradientUnits="userSpaceOnUse"
                    >
                        {/* gradient avec couleur  */}
                        {/*       <stop offset="0" stop-color="#008d36" />
            <stop offset="1" stop-color="#6db755" /> */}
                        <stop offset="0" stopColor="#fff" />
                        <stop offset="1" stopColor="#fff" />
                    </linearGradient>
                </defs>

                <g id="Layer_2" data-name="Layer 2">
                    <g id="Layer_1-2" data-name="Layer 1">
                        <path
                            className="cls-1"
                            d="M38.2,17.44C65.48-2.7,104-5.45,134.09,10c16,7.49,27.21,21.61,40,33.3C143.22,74.63,112,105.52,81,136.68c15.18,3.17,32.1-.52,43-12,31-31.06,62.15-62,93-93.21C235.51,10.17,264.14-1.81,292.35.22c43.54,1.89,82.51,38.83,86,82.41,5.72,44.72-26.75,89.88-70.6,99.55-41,10.46-87.15-11.64-104.49-50.31,12.9-12.16,24.9-25.22,37.75-37.4.19,24.19,22.78,44.71,46.8,43.22,23.77.07,44.89-21.59,43.93-45.38.86-21.14-15.84-41-36.54-44.57-14.09-2.65-30.08,1.08-39.9,12q-46.08,46.16-92.21,92.21c-24.41,28.41-66.1,40.54-101.56,27.5-28.83-9.94-52-35.16-58.74-65C-6.52,78.85,8,38.48,38.2,17.44ZM61.7,58.32A45,45,0,0,0,48,103.16C66.41,84.77,84.78,66.25,103.42,48,88.86,44.69,72.65,47.84,61.7,58.32Z"
                        />
                    </g>
                </g>
            </svg>
        </div>
    );
export const HelpIcon = () => (
    <Tooltip
        placement="right"
        title={<FormattedMessage id="sideMenu.hoverMessages.Documentation" />}
    >
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width={35} height={35}>
            <path
                d="M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm169.8-90.7c7.9-22.3 29.1-37.3 52.8-37.3h58.3c34.9 0 63.1 28.3 63.1 63.1c0 22.6-12.1 43.5-31.7 54.8L280 264.4c-.2 13-10.9 23.6-24 23.6c-13.3 0-24-10.7-24-24V250.5c0-8.6 4.6-16.5 12.1-20.8l44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1c0-8.4-6.8-15.1-15.1-15.1H222.6c-3.4 0-6.4 2.1-7.5 5.3l-.4 1.2c-4.4 12.5-18.2 19-30.6 14.6s-19-18.2-14.6-30.6l.4-1.2zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"
                style={{ fill: 'white' }}
            />
        </svg>
    </Tooltip>
);

export const CheckIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" width={12} height={12}>
        <path
            fill="#ffffff"
            d="M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7 393.4 105.4c12.5-12.5 32.8-12.5 45.3 0z"
        />
    </svg>
);

export const XmarkIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512" width={12} height={12}>
        <path
            fill="#ffffff"
            d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z"
        />
    </svg>
);
export const GeofenceIcon = (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 448 512" {...props}>
        <path d="M96 151.4V360.6c9.7 5.6 17.8 13.7 23.4 23.4H328.6c0-.1 .1-.2 .1-.3l-4.5-7.9-32-56 0 0c-1.4 .1-2.8 .1-4.2 .1c-35.3 0-64-28.7-64-64s28.7-64 64-64c1.4 0 2.8 0 4.2 .1l0 0 32-56 4.5-7.9-.1-.3H119.4c-5.6 9.7-13.7 17.8-23.4 23.4zM384.3 352c35.2 .2 63.7 28.7 63.7 64c0 35.3-28.7 64-64 64c-23.7 0-44.4-12.9-55.4-32H119.4c-11.1 19.1-31.7 32-55.4 32c-35.3 0-64-28.7-64-64c0-23.7 12.9-44.4 32-55.4V151.4C12.9 140.4 0 119.7 0 96C0 60.7 28.7 32 64 32c23.7 0 44.4 12.9 55.4 32H328.6c11.1-19.1 31.7-32 55.4-32c35.3 0 64 28.7 64 64c0 35.3-28.5 63.8-63.7 64l-4.5 7.9-32 56-2.3 4c4.2 8.5 6.5 18 6.5 28.1s-2.3 19.6-6.5 28.1l2.3 4 32 56 4.5 7.9z" />
    </svg>
);
export const EditIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 512 512">
        <path d="M410.3 231l11.3-11.3-33.9-33.9-62.1-62.1L291.7 89.8l-11.3 11.3-22.6 22.6L58.6 322.9c-10.4 10.4-18 23.3-22.2 37.4L1 480.7c-2.5 8.4-.2 17.5 6.1 23.7s15.3 8.5 23.7 6.1l120.3-35.4c14.1-4.2 27-11.8 37.4-22.2L387.7 253.7 410.3 231zM160 399.4l-9.1 22.7c-4 3.1-8.5 5.4-13.3 6.9L59.4 452l23-78.1c1.4-4.9 3.8-9.4 6.9-13.3l22.7-9.1 0 32c0 8.8 7.2 16 16 16l32 0zM362.7 18.7L348.3 33.2 325.7 55.8 314.3 67.1l33.9 33.9 62.1 62.1 33.9 33.9 11.3-11.3 22.6-22.6 14.5-14.5c25-25 25-65.5 0-90.5L453.3 18.7c-25-25-65.5-25-90.5 0zm-47.4 168l-144 144c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l144-144c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z" />
    </svg>
);
export const deleteIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 448 512">
        <path d="M135.2 17.7C140.6 6.8 151.7 0 163.8 0L284.2 0c12.1 0 23.2 6.8 28.6 17.7L320 32l96 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 96C14.3 96 0 81.7 0 64S14.3 32 32 32l96 0 7.2-14.3zM32 128l384 0 0 320c0 35.3-28.7 64-64 64L96 512c-35.3 0-64-28.7-64-64l0-320zm96 64c-8.8 0-16 7.2-16 16l0 224c0 8.8 7.2 16 16 16s16-7.2 16-16l0-224c0-8.8-7.2-16-16-16zm96 0c-8.8 0-16 7.2-16 16l0 224c0 8.8 7.2 16 16 16s16-7.2 16-16l0-224c0-8.8-7.2-16-16-16zm96 0c-8.8 0-16 7.2-16 16l0 224c0 8.8 7.2 16 16 16s16-7.2 16-16l0-224c0-8.8-7.2-16-16-16z" />
    </svg>
);

export const CopyIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 448 512">
        <path
            fill="white"
            d="M384 336l-192 0c-8.8 0-16-7.2-16-16l0-256c0-8.8 7.2-16 16-16l140.1 0L400 115.9 400 320c0 8.8-7.2 16-16 16zM192 384l192 0c35.3 0 64-28.7 64-64l0-204.1c0-12.7-5.1-24.9-14.1-33.9L366.1 14.1c-9-9-21.2-14.1-33.9-14.1L192 0c-35.3 0-64 28.7-64 64l0 256c0 35.3 28.7 64 64 64zM64 128c-35.3 0-64 28.7-64 64L0 448c0 35.3 28.7 64 64 64l192 0c35.3 0 64-28.7 64-64l0-32-48 0 0 32c0 8.8-7.2 16-16 16L64 464c-8.8 0-16-7.2-16-16l0-256c0-8.8 7.2-16 16-16l32 0 0-48-32 0z"
        />
    </svg>
);

export const ChevronUp = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 512 512">
        <path
            fill="#999999"
            d="M233.4 105.4c12.5-12.5 32.8-12.5 45.3 0l192 192c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L256 173.3 86.6 342.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l192-192z"
        />
    </svg>
);
export const ChevronDown = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 512 512">
        <path
            fill="#999999"
            d="M233.4 406.6c12.5 12.5 32.8 12.5 45.3 0l192-192c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L256 338.7 86.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l192 192z"
        />
    </svg>
);
